/*eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Table,
  Dropdown,
  Input,
  TableCell,
  Grid
} from "semantic-ui-react";
import { Table as TableB } from 'react-bootstrap'
import {
  Form as Formiker,
  Field as Fieldmik,
  FieldArray,
  Formik,
  getIn,
  ErrorMessage,
} from "formik";
import {
  MyInput,
  MyNormalInput,
  MyNumInput,
  MyTextArea,
} from "../dynamicComponent/myInputs";
import { connect } from "react-redux";
import Axios from "axios";
import * as yup from "yup";
import cogoToast from "cogo-toast";
import { createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import ErrorMessages from "./ErrorMessages";
import { successAlertDispatcher, errorAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import DropLocation from "../dynamicComponent/locationDrop";
import ModalCreateConsignee from "./modalCreateConsignee";
import ModalCreateConsignor from "./modalCreateConsigner";
import SearchDropdown from "./searchDropdown";
import MyConsigneeComponent from "../dynamicComponent/consignee";
import MyConsignor from "../dynamicComponent/consignor";
import MyVendorComponent from "../dynamicComponent/vendorSearch";
import MyBillingPartyComponent from "../dynamicComponent/billingparty";
import BillingPartyDropdown from "../dynamicComponent/billingPartyDropdown";
import ReadMasterAxios from "../axiosComponent/readMaster";
import moment from "moment";
import BillingPartyBranchDropdown from "../dynamicComponent/billingPartyBranchDropdown";
import ModeOfTransportDropdown from "../dropdowns/modeOfTransportDropdown";
import MyPSLineItem from '../apiInputs/mypslineItem'
import { DATE_DDMMyyyy, billingPartyUserAccess, LOCAL_STORAGE, FEATURES, deliverOrderDetailsAccess, alloted_orders_quantity, TransactionTypes } from "../../utils/constant";
import { FILE_DELETED, INVALID_FIELDS, INVALID_FILE_TYPE } from "../../utils/validationConstant";
import { AllRegex } from "../../utils/validation";
import MyUser from "../apiInputs/myUser";
import MyTransactionTypes from "../apiInputs/transactionType";
import MyCompanyCode from "../apiInputs/myCompanyCode";
import MyGLCode from "../apiInputs/myGLCode";
import MyCostCenter from "../apiInputs/myCostCenter";

const ModalJobOrder = (props, { setFieldValue }) => {
  const getIntialCall = async () => {
    let [productsArray, dataArray, serviceArray, loadArray, branchArray] =
      await Promise.all([
        ReadAxios({ url: "skuMaster" }),
        ReadAxios({ url: `vehicleTypeMaster` }),
      ]);
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    serviceArray = isEmpty(serviceArray) ? [] : serviceArray.data;
    loadArray = isEmpty(loadArray) ? [] : loadArray.data;
    productsArray = isEmpty(productsArray) ? [] : productsArray.data.resultSet;

    if (branchArray)
      setbranchArray(
        branchArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.branchName,
            value: item.branchId,
            raw: { ...item },
          };
        })
      );

    if (dataArray)
      setvehicletype(
        dataArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.vehicleType + " " + "(" + item.vehicleTypeTonnage + ")",
            value: item.vehicleTypeId,
            raw: { ...item },
          };
        })
      );

    if (productsArray) {
      setproducts(
        productsArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.skuCode,
            value: item.skuCode,
            raw: { ...item },
          };
        })
      );
    }
  };

  const [yard, setyard] = useState([]);
  const [cha, setcha] = useState([]);
  const [shipingline, setshipingline] = useState([]);
  const [products, setproducts] = useState([]);
  const [packageType, setPackageType] = useState([]);
  const [vehicles, setvehicletype] = useState([]);
  const [ownership, setownershiptype] = useState([]);
  const [customertype, setcustomertype] = useState([]);
  const [billingpartybranch, setBillingPartyBranch] = useState([]);
  const [branchs, setbranchArray] = useState([]);
  const [userbranchs, setUserbranchArray] = useState([]);
  const [ownvendor, setOwnVendor] = useState([]);
  const [containerType, setcontainerType] = useState([]);
  const [service, setService] = useState([]);
  const [load, setLoad] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [checkowner, setcheckowner] = useState(2);
  const [consignorArray, setConsignorArray] = useState([]);
  const [consigneeArray, setConsigneeArray] = useState([]);
  const [serviceCateogyList, setServiceCateogyList] = useState([]);
  const [disabledCftFactor, setDisabledCftFactor] = useState(false);
  const [enablePhysicalLR, setEnablePhysicalLR] = useState(false)
  const [enableOtherDocs, setEnableOtherDocs] = useState(false)
  const [enableInvoiceDoc, setEnableInvoiceDoc] = useState(false)
  const [enableEwayDoc, setEnableEwayDoc] = useState(false)
  const [quantityModal, setQuantityModal] = useState(false)
  const [quantityIndex, setQuantityIndex] = useState(0)
  const [containerSizeList, setContainerSizeList] = useState([])
  const [lrNumbers, setLrNumbers] = useState({})
  const [uomValues, setUomValues] = useState([])


  useEffect(() => {
    getServiceType();
    getOwnershipType();
    getShipingLine();
    getYard();
    getCha();
    getCustomerType();
    getBranch();
    getLoadType();
    getIntialCall();
    getCurrentUserBranch();
    getOwnVendors();
    getContainerType();
    getServiceCategory();
    getPackageType();
    getContainerSizeArray();
    getUomValues()
  }, []);

  const getPackageType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/packaging_type`,
    })
      .then((result) => {
        let data = result.data.resultSet;
        let list = data.map((item, index) => {
          return {
            key: item.packagingTypeId,
            text: item.packagingType,
            value: item.packagingTypeId,
            raw: { ...item },
          };
        });
        setPackageType(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUomValues = () => {
    ReadAxios({
      url: `unitOfMeasurement`,
    })
      .then((result) => {
        let data = result?.data?.resultSet;
        if(data && data.length){
          let list = data.map((item, index) => {
            return {
              key: item.uomId,
              text: item.unit,
              value: item.uomId,
              raw: { ...item },
            };
          });
          setUomValues(list);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getServiceCategory = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/service_category`,
    })
      .then((result) => {
        let data = result.data.resultSet;
        let list = data.map((item, index) => {
          return {
            key: item.serviceCategoryId,
            text: item.serviceCategory,
            value: item.serviceCategoryId,
            raw: { ...item },
          };
        });
        setServiceCateogyList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOwnVendors = () => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`,
    }).then((result) => {
      let tempown = [];
      let vendorData = result.data.resultSet;
      for (let index = 0; index < vendorData.length; index++) {
        if (vendorData[index].vendorOwnershipType == 1) {
          tempown.push(vendorData[index]);
        }
      }
      setOwnVendor(
        tempown.map((item, index) => {
          return {
            key: index + 1,
            text: item.transporterName,
            value: item.transporterMasterId,
            raw: { ...item },
          };
        })
      );
    });
  };

  const handleLRSeriesNo = async (bookingBranchId, index, setFieldValue) => {
    if(lrNumbers && lrNumbers[index] && lrNumbers[index][bookingBranchId]){
      var difference = (new Date() - lrNumbers[index][bookingBranchId].time);
      difference = Math.round((difference/1000)/60);
      if(difference >= 30 ){
        let lr_numbers = lrNumbers
        lr_numbers[index][bookingBranchId]=null
        setLrNumbers(lr_numbers)
      }else{
        if (index || index === 0) {
        setFieldValue(`deliveries[${index}].lr_no`, lrNumbers[index][bookingBranchId].lrNumber)
        setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
        }
      }
    }else{
      let lrNumber = await getLRSeriesNumber(bookingBranchId)
      if (lrNumber) {
        let currentTime = new Date()
        let lr_numbers = lrNumbers
        console.log(lr_numbers,'lr numbers', index,'index',bookingBranchId,'bookingBranch Id');
        lr_numbers[index] = lr_numbers[index] || {}
        lr_numbers[index][bookingBranchId] = {lrNumber,time : currentTime}
        setLrNumbers(lr_numbers)
        if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, lrNumber)
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
        }
      }else{
        if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, "")
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, false)
        }
      }
    }
  }
  const getLRSeriesNumber = async (bookingBranchId) => {
    try {
      let lrResponse = await ReadAxios({ completeURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/lrseries/lrnumber?branch_id=${bookingBranchId}` })
      return lrResponse?.data?.lr_number;
    } catch (err) {
      props.errorAlertDispatcher({
        type: "error",
        messageHeader: "Error",
        messageBody: err.response?.data?.message || "Couldn't Fetch LR Number From LR Series",
      });
      return false
      console.log(err);
    }
  }

  const evaluateFreightRate = (value, setFieldValue, proposedFreightRate, actualFreightRate, finalFreightRate, CFTKGFactor, chargedWeight, cftKgEnable, finalRate, charges, index) => {
    setFieldValue(cftKgEnable, true)
    // let optionsUOM = [
    //   { key: "4", text: "Trip", value: "trip" },
    //   { key: "2", text: "KG", value: "kg" },
    //   { key: "5", text: "Ton", value: "ton" },
    //   { key: "6", text: "KM", value: "km" },
    //   { key: "7", text: "Per Case", value: "percase" },
    //   { key: "8", text: "CFT", value: "cft" },
    //   { key: "9", text: "CFT KG Factor", value: "CFTKGFactor" },
    // ]
    let UomSelected = value.deliveries[index].uom
    let selectedUOMName = uomValues.find((data)=> data.value == value.deliveries[index].uom)?.text
    // optionsUOM.forEach(element => {
    //   if (element.value == value.deliveries[index].uom) {
    //     UomSelected = element.key;
    //   }
    // });

    let UoMCFTFactorCalculation = 0;


    value.deliveries.forEach(element => {
      if (element?.products?.length > 0) {
        element.products.forEach(products => {
          let temp = products.length * products.breadth * products.height * products.quantity;
          if (!isNaN(temp))
            UoMCFTFactorCalculation = UoMCFTFactorCalculation + temp;
          else
            UoMCFTFactorCalculation = UoMCFTFactorCalculation
        });
      }
    });

    let chargedWeightValue = value.deliveries[index].charged_weight; //2,5
    let totalWeightValue = value.deliveries[index].total_quantity; //7


    ReadAxios({
      baseURL: `${process.env.REACT_APP_TA_API_URL}`,
      url: `orders/freight/rate`,
      readItems: {
        customer_no: LOCAL_STORAGE.customerNo,
        user_id: LOCAL_STORAGE.userId,
        trip_type_id: "1",
        movement_type: props.values.values.movement_type,
        billing_party_id: value.deliveries[index].billing_party_id,
        route_id: props.values.rcode,//props.values.values.route_code,
        proposed_vehicle_type: value.proposed_vehicle_type,
        consignor_id: value.deliveries[index].consignor_id,
        consignee_id: value.deliveries[index].consignee_id,
        vendor_id: value.vendor_id,
        booking_branch_id: value.booking_branch_id,
        container_type_id: value.deliveries[index].container_type_id,
        uom: UomSelected,
        load_type_id: value.load_type_id,
        date: moment(value?.deliveries?.[index]?.lr_date ? value.deliveries[index].lr_date : new Date()).format("YYYY-MM-DD"),
        engine_type_id: 2,
        //expense_particular_id: "101",
        rate_type_id: 1,
        total_no_of_boxes : value.deliveries[index].total_quantity,
        mode_of_transport : value.mode_of_transport
        //loading_pattern_id: "0",
      },
    })
      .then((result) => {
        if (result?.data?.data?.amount) {
          //CFTKGFactor
          if (value?.deliveries?.[index]?.actual_freight_rate && value?.deliveries?.[index]?.final_freight_rate && value.deliveries[index].actual_freight_rate != 0 && value.deliveries[index].final_freight_rate != null) {
            let amountFromAPI = result.data.data.amount;
            let cftFactorFromAPI = result.data.data.CFTKGFactor;
            let calculatedAmount = amountFromAPI * (value.deliveries[index].final_freight_rate / value.deliveries[index].actual_freight_rate)

            if (cftFactorFromAPI > 0 && selectedUOMName == "PER CFT KG") {
              calculatedAmount = calculatedAmount * cftFactorFromAPI;
              let previousCFT = +value.deliveries[index].cft_kg_factor
              if (previousCFT > 0) {
                calculatedAmount = calculatedAmount / previousCFT;
              }
            }

            setFieldValue(proposedFreightRate, amountFromAPI)
            setFieldValue(actualFreightRate, amountFromAPI)
            if (cftFactorFromAPI && Number(cftFactorFromAPI) > 0) {
              setDisabledCftFactor(true)
            } else {
              setDisabledCftFactor(false)
            }
            setFieldValue(CFTKGFactor, cftFactorFromAPI)

            setFrieghtValueCalculation(selectedUOMName, chargedWeightValue, totalWeightValue, amountFromAPI, UoMCFTFactorCalculation, cftFactorFromAPI, chargedWeight, finalFreightRate, calculatedAmount, setFieldValue, index)
          } else {
            let amountFromAPI = result.data.data.amount;
            let cftFactorFromAPI = result.data.data.CFTKGFactor;
            let calculatedAmount = amountFromAPI;
            if (cftFactorFromAPI > 0 && selectedUOMName == "PER CFT KG") {
              calculatedAmount = calculatedAmount * cftFactorFromAPI;
              let previousCFT = +value.deliveries[index].cft_kg_factor
              if (previousCFT > 0) {
                calculatedAmount = calculatedAmount / previousCFT;
              }
            }
            setFieldValue(proposedFreightRate, amountFromAPI)
            setFieldValue(actualFreightRate, amountFromAPI)
            if (cftFactorFromAPI && Number(cftFactorFromAPI) > 0) {
              setDisabledCftFactor(true)
            } else {
              setDisabledCftFactor(false)
            }
            setFieldValue(CFTKGFactor, cftFactorFromAPI)
            setFrieghtValueCalculation(selectedUOMName, chargedWeightValue, totalWeightValue, amountFromAPI, UoMCFTFactorCalculation, cftFactorFromAPI, chargedWeight, finalFreightRate, calculatedAmount, setFieldValue, index)
          }
        }
      })
      .catch((err) => {
        setFieldValue(finalFreightRate, 0)
        setFieldValue(CFTKGFactor, 0)
        setDisabledCftFactor(false)
        console.log(err);
      });
    value.deliveries.map((obj) => {
      return setFieldValue(finalRate, +obj.charges + 0)
    })
  };

  const setFrieghtValueCalculation = (UomSelected, chargedWeightValue, totalWeightValue, amountFromAPI, UoMCFTFactorCalculation, cftFactorFromAPI, chargedWeight, finalFreightRate, calculatedAmount, setFieldValue, index) => {
    if ((UomSelected && UomSelected.toUpperCase() == "TRIP")) {
      setFieldValue(finalFreightRate, amountFromAPI)
      setFieldValue(`deliveries[${index}].final_rate`, amountFromAPI)
    }

    if (UomSelected && (UomSelected.toUpperCase() == "KG" || UomSelected.toUpperCase() == "TON") && !isNaN(chargedWeightValue) && +chargedWeightValue > 0) {
      if(UomSelected.toUpperCase() == "KG"){
        chargedWeightValue = FEATURES.weightInTonCustomers ? (Number(chargedWeightValue) * 1000) : Number(chargedWeightValue);
      }else{
        chargedWeightValue = FEATURES.weightInTonCustomers ? Number(chargedWeightValue) : (Number(chargedWeightValue) / 1000);
      }
      let tempCalculation = amountFromAPI * chargedWeightValue
      setFieldValue(finalFreightRate, tempCalculation)
      setFieldValue(`deliveries[${index}].final_rate`, tempCalculation)
    } else if (UomSelected && (UomSelected.toUpperCase() == "KG" || UomSelected.toUpperCase() == "TON")) {
      setFieldValue(finalFreightRate, 0)
      setFieldValue(`deliveries[${index}].final_rate`, 0)
    }

    if (UomSelected && (UomSelected.toUpperCase() == "PER CASE") && !isNaN(totalWeightValue) && +totalWeightValue > 0) {
      let tempCalculation = amountFromAPI * totalWeightValue
      setFieldValue(finalFreightRate, tempCalculation)
      setFieldValue(`deliveries[${index}].final_rate`, tempCalculation)
    } else if (UomSelected && (UomSelected.toUpperCase() == "PER CASE")) {
      setFieldValue(finalFreightRate, 0)
      setFieldValue(`deliveries[${index}].final_rate`, 0)
    }

    if (UomSelected && (UomSelected.toUpperCase() == "KM") && !isNaN(props.bdistance) && +props.bdistance > 0) {
      let distance = props.bdistance
      let tempCalculation = amountFromAPI * distance
      setFieldValue(finalFreightRate, tempCalculation)
      setFieldValue(`deliveries[${index}].final_rate`, tempCalculation)
    } else if (UomSelected && (UomSelected.toUpperCase() == "KM")) {
      setFieldValue(finalFreightRate, 0)
      setFieldValue(`deliveries[${index}].final_rate`, 0)
    }

    if (UomSelected && (UomSelected.toUpperCase() == "CFT" || UomSelected.toUpperCase() == "PER CFT KG") && +UoMCFTFactorCalculation > 0) {
      if (UomSelected.toUpperCase() == "PER CFT KG") {
        let volumeWithCFT = cftFactorFromAPI * UoMCFTFactorCalculation;
        setFieldValue(chargedWeight, volumeWithCFT)
        setFieldValue(finalFreightRate, calculatedAmount)
        setFieldValue(`deliveries[${index}].final_rate`, calculatedAmount)
      }
      if (UomSelected.toUpperCase() == "CFT") {
        setFieldValue(finalFreightRate, calculatedAmount)
        setFieldValue(`deliveries[${index}].final_rate`, calculatedAmount)
      }
    } else if (UomSelected && (UomSelected.toUpperCase() == "CFT" || UomSelected.toUpperCase() == "PER CFT KG")) {
      setFieldValue(finalFreightRate, 0)
      setFieldValue(`deliveries[${index}].final_rate`, 0)
    }

    if (UomSelected && (UomSelected.toUpperCase() == "PER TON PER KM") && !isNaN(props.bdistance) && +props.bdistance > 0 && !isNaN(chargedWeightValue) && +chargedWeightValue > 0) {
      let distance = Number(props.bdistance)
      let weight_in_ton = FEATURES.weightInTonCustomers ? Number(chargedWeightValue) : Number(chargedWeightValue)/1000
      let tempCalculation = amountFromAPI * distance * weight_in_ton
      setFieldValue(finalFreightRate, tempCalculation)
      setFieldValue(`deliveries[${index}].final_rate`, tempCalculation)
    } else if (UomSelected && (UomSelected.toUpperCase() == "PER TON PER KM")) {
      setFieldValue(finalFreightRate, 0)
      setFieldValue(`deliveries[${index}].final_rate`, 0)
    }
  }

  const getContainerType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/container_type`,
    })
      .then((result) => {
        let containerData = result.data.resultSet;
        setcontainerType(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.containerType,
              name: item.containerTypeCode,
              value: item.containerTypeId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCha = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/cha` })
      .then((result) => {
        let containerData = result.data.resultSet;
        setcha(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.CHAName,
              value: item.CHAId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getShipingLine = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/shippingLine`,
    })
      .then((result) => {
        let containerData = result.data.resultSet;
        setshipingline(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.shippingLine,
              value: item.shippingLineId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getYard = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/yard` })
      .then((result) => {
        let containerData = result.data.resultSet;
        setyard(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: `${item.yardCode} - ${item.yardName}`,
              value: item.yardId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCurrentUserBranch = () => {
    let temparray = LOCAL_STORAGE.branch_Ids
    ReadAxios({
      url: `branch`,
      mainUserId: LOCAL_STORAGE.userId,
    })
      .then((res) => {
        setLoading(false);
        let branchArray = res.data.resultSet;
        if (temparray != "") {
          let temp = temparray.split(",");
          let tempa = [];
          for (let index = 0; index < branchArray.length; index++) {
            for (let indexj = 0; indexj < temp.length; indexj++) {
              if (branchArray[index].branchId == +temp[indexj]) {
                tempa.push(branchArray[index]);
              }
            }
          }
          setUserbranchArray(
            tempa.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        } else {
          setUserbranchArray(
            branchArray.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkOwnership = (data) => {
    setcheckowner(data.value);
  };

  const getBranch = () => {
    ReadAxios({
      url: `branch`,
      mainUserId: LOCAL_STORAGE.userId,
    })
      .then((res) => {
        setLoading(false);
        let branchArray = res.data.resultSet;
        setbranchArray(
          branchArray.map((item, index) => {
            return {
              key: index + 1,
              text: item.branchName,
              value: item.branchName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getServiceType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/service/type`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        setLoading(false);
        let service = res.data.data;
        setService(
          service.map((item, index) => {
            return {
              key: index,
              value: item.service_type_id,
              text: item.service_type_name,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOwnershipType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`,
    })
      .then((res) => {
        setLoading(false);
        let ownership = res.data.resultSet;
        setownershiptype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.vehicleOwnershipTypeId,
              text: item.vehicleOwnershipTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCustomerType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billingPartyPaymentType`,
    })
      .then((res) => {
        setLoading(false);
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkBillingParty = (name, data, setFieldValue, customerTypeId, customerTypeName) => {
    let btemparray = LOCAL_STORAGE.billing_Party_Branch_Ids;
    if (billingPartyUserAccess) {
      ReadMasterAxios({
        completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping?${data.value}`,
        mainUserId: LOCAL_STORAGE.userId,
        billingPartyId: data.value,
      }).then((res) => {
        if (res.data.status == 200) {
          let ownership = res.data.resultSet[0].paymentType;
          setcustomertype(
            ownership.map((item, index) => {
              return {
                key: index,
                value: item.id,
                text: item.name,
                raw: { ...item },
              };
            })
          );
          setFieldValue(customerTypeId, ownership[0].id)
          setFieldValue(customerTypeName, ownership[0].name)
        }
        else if (res.data.status == 204) {
          getCustomerType()
        }
      }).catch((err) => {

      })

    }

    ReadMasterAxios({
      completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_branch`,
      mainUserId: LOCAL_STORAGE.userId,
      billingPartyId: data.value,
    })
      .then((response) => {
        let options = response.data.resultSet;
        if (btemparray != "") {
          let btemp = btemparray.split(",");
          let btempa = [];
          for (let index = 0; index < options.length; index++) {
            for (let indexj = 0; indexj < btemp.length; indexj++) {
              if (options[index].billingPartyBranchId == +btemp[indexj]) {
                btempa.push(options[index]);
              }
            }
          }
          setBillingPartyBranch(
            btempa.map((item, index) => {
              return {
                key: index,
                value: item.billingPartyBranchId,
                text: item.billingPartyBranchName,
                raw: { ...item },
              };
            })
          );
        } else {
          setBillingPartyBranch(
            options.map((item, index) => {
              return {
                key: index,
                value: item.billingPartyBranchId,
                text: item.billingPartyBranchName,
                raw: { ...item },
              };
            })
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const getLoadType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`,
    })
      .then((res) => {
        setLoading(false);
        let load = [];

        let loadtypeRes = res.data.data

        if (FEATURES.frozenAsRefeer) {
          loadtypeRes.forEach(element => {
            if (element.load_type_name == "Frozen") {
              element.load_type_name = 'Reefer'
            }
          });
          let newLoadType = loadtypeRes.filter((type) => {
            if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
              return type
            }
          })

          load = newLoadType;
        }
        else {
          load = loadtypeRes;
        }

        setLoad(
          load.map((item, index) => {
            return {
              key: index,
              value: item.load_type_id,
              text: item.load_type_name,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addNewDelivery = (arrayHelpers) => {
    if (props.shipment.create.movement_type == "import") {
      if (
        props.shipment.create.no_of_vehicles <=
        arrayHelpers.form.values.deliveries.length
      ) {
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Warning",
          messageBody:
            "Can not create more Deliveries then required containers.",
        });
      } else {
        arrayHelpers.push({
          delivery_number: "",
          delivery_reference_no: null,
          booking_branch_id: null,
          booking_branch_name: "",
          billing_branch_id: null,
          billing_branch_name: "",
          lr_no: null,
          is_lr_generated_by_lr_series: false,
          lr_date: props.reqon,
          lr_date_t: props.reqon,
          transporter_lr_no: null,
          actual_weight: null,
          gross_weight: null,
          charged_weight: null,
          grossWeightFlag: true,
          chargedWeightFlag: true,
          total_quantity: null,
          customer_type_id: null,
          billing_party_id: null,
          billing_party_name : "",
          billing_party_branch_id: null,
          billing_party_branch_name: "",
          deliver_to: "consignee",
          deliver_to_branch_id: null,
          deliver_to_address: null,
          remarks: null,
          consignor_code: "",
          consignor_id: "",
          consignor_name: "",
          consignee_code: "",
          pickup_area: "",
          drop_area: "",
          consignee_id: "",
          consignee_name: "",
          consignee_address: "",
          consignor_address: "",
          consignor_gstNumber: "",
          consignee_gstNumber: "",
          container_no: null,
          container_type: null,
          container_type_id: null,
          container_seal_no: "",
          yard_id: null,
          shipping_line_id: null,
          cha_id: null,
          container_pickup_date: props.reqon,
          container_pickup_date_t: props.reqon,
          delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),
          delivery_date_t: moment(props.reqon).add(props.btime, "h").toDate(),
          boarding_no: null,
          import_declaration_no: null,
          do_no: null,
          do_validity_date: null,
          do_validity_date_t: null,
          proposed_freight_rate: 0,
          actual_freight_rate: 0,
          final_freight_rate: 0,
          final_rate: 0,
          uom: 4,
          uom_name : "TRIP",
          cft_kg_factor: 0,
          cft_kg_enable: false,
          insurance_no : null,
          contractual_customer_id : null,
          products: [
            {
              product_code: null,
              product_name: null,
              quantity: null,
              product_category_id: null,
              packaging_type_id: null,
              invoice_no: null,
              length: 0,
              breadth: 0,
              height: 0,
            },
          ],
          invoices: [
            {
              invoice_no: null,
              invoice_date: null,
              invoice_quantity: null,
              invoice_amount: null,
              bl_no: null,
              eway_bill_no: null,
              eway_bill_expirydate: null
            },
          ],
          lrOtherCharges: [
            {
              charges: null,
              charge_type_id: null,
            }
          ]
        });
      }
    } else {
      arrayHelpers.push({
        delivery_number: "",
        delivery_reference_no: null,
        booking_branch_id: null,
        booking_branch_name: "",
        billing_branch_id: null,
        billing_branch_name: "",
        lr_no: null,
        is_lr_generated_by_lr_series: false,
        lr_date: props.reqon,
        lr_date_t: props.reqon,
        transporter_lr_no: null,
        actual_weight: null,
        gross_weight: null,
        charged_weight: null,
        grossWeightFlag: true,
        chargedWeightFlag: true,
        total_quantity: null,
        customer_type_id: null,
        billing_party_id: null,
        billing_party_name : "",
        billing_party_branch_id: null,
        deliver_to: "consignee",
        deliver_to_branch_id: null,
        billing_party_branch_name: "",
        deliver_to_address: null,
        remarks: null,
        other: null,
        consignor_code: "",
        consignor_name: "",
        consignee_code: "",
        consignee_name: "",
        pickup_area: "",
        drop_area: "",
        consignee_id: "",
        consignor_id: "",
        consignee_address: "",
        consignor_address: "",
        consignor_gstNumber: "",
        consignee_gstNumber: "",
        container_no: null,
        container_type: null,
        container_type_id: null,
        container_seal_no: "",
        yard_id: null,
        shipping_line_id: null,
        cha_id: null,
        container_pickup_date: props.reqon,
        container_pickup_date_t: props.reqon,
        delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),
        delivery_date_t: moment(props.reqon).add(props.btime, "h").toDate(),
        do_no: null,
        boarding_no: null,
        import_declaration_no: null,
        do_validity_date: null,
        do_validity_date_t: null,
        proposed_freight_rate: 0,
        actual_freight_rate: 0,
        final_freight_rate: 0,
        final_rate: 0,
        uom: 4,
        uom_name : "TRIP",
        cft_kg_factor: 0,
        cft_kg_enable: false,
        insurance_no : null,
        contractual_customer_id : null,
        products: [
          {
            product_code: null,
            product_name: null,
            quantity: null,
            product_category_id: null,
            packaging_type_id: null,
            invoice_no: null,
            length: 0,
            breadth: 0,
            height: 0,
          },
        ],
        invoices: [
          {
            invoice_no: null,
            invoice_date: null,
            invoice_quantity: null,
            invoice_amount: null,
            bl_no: null,
            eway_bill_no: null,
            eway_bill_expirydate: null
          },
        ],
        lrOtherCharges: [
          {
            charges: null,
            charge_type_id: null,
          }
        ]
      });
    }
  };

  const decideInitialValue =
    props.editOrderIndex !== null
      ? { ...props.editOrderData }
      : {
        // order_number: "",
        order_reference_no: null,
        gross_weight: 1,
        net_weight: 1,
        proposed_vehicle_type: "",
        ownership_type_id: 2,
        proposed_vehicle_type_name: "",
        vendor_id: undefined,
        vendor_name: "",
        vehicle_number: "",
        booking_branch_id: null,
        booking_branch_name: "",
        freight_rate: "0",
        service_type_id: 1,
        load_type_id: 4,
        min_temp: null,
        max_temp: null,
        mode_of_transport : 1,
        deliveries: [
          {
            delivery_number: "",
            delivery_reference_no: null,
            booking_branch_id: null,
            booking_branch_name: "",
            billing_branch_id: null,
            billing_branch_name: "",
            lr_no: null,
            is_lr_generated_by_lr_series: false,
            lr_date: props.reqon,
            lr_date_t: props.reqon,
            transporter_lr_no: null,
            actual_weight: null,
            gross_weight: null,
            charged_weight: null,
            grossWeightFlag: true,
            chargedWeightFlag: true,
            total_quantity: null,
            customer_type_id: null,
            customer_type_name: null,
            billing_party_id: null,
            billing_party_name : "",
            billing_party_branch_id: null,
            deliver_to: "consignee",
            deliver_to_branch_id: null,
            billing_party_branch_name: "",
            deliver_to_address: null,
            remarks: null,
            other: null,
            consignor_code: "",
            consignor_name: "",
            consignee_code: "",
            consignee_name: "",
            pickup_area: "",
            drop_area: "",
            consignee_id: "",
            consignor_id: "",
            consignee_address: "",
            consignor_address: "",
            consignor_gstNumber: "",
            consignee_gstNumber: "",
            insurance_no : "",
            contractual_customer_id : "",
            container_no: null,
            container_pickup_date: props.reqon,
            container_pickup_date_t: props.reqon,
            delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),
            delivery_date_t: moment(props.reqon)
              .add(props.btime, "h")
              .toDate(),
            container_drop_location: null,
            storage_expiration_date: null,
            storage_expiration_date_t: null,
            container_type: null,
            container_type_id: null,
            container_seal_no: "",
            yard_id: null,
            shipping_line_id: null,
            cha_id: null,
            demurrage_expiration_date: null,
            demurrage_expiration_date_t: null,
            ata_date: null,
            ata_date_t: null,
            boarding_no: null,
            import_declaration_no: null,
            do_no: null,
            do_validity_date: null,
            do_validity_date_t: null,
            proposed_freight_rate: 0,
            actual_freight_rate: 0,
            final_freight_rate: 0,
            final_rate: 0,
            cft_kg_factor: 0,
            cft_kg_enable: false,
            uom: 4,
            uom_name : "TRIP",
            products: [
              {
                product_code: null,
                product_name: null,
                quantity: null,
                product_category_id: null,
                packaging_type_id: null,
                invoice_no: null,
                length: 0,
                breadth: 0,
                height: 0,
              },
            ],
            invoices: [
              {
                invoice_code: null,
                invoice_date: null,
                invoice_quantity: null,
                invoice_amount: null,
                eway_bill_no: null,
                eway_bill_expirydate: null
              },
            ],
            lr_other_charges: [
              {
                charges: null,
                charge_type_id: null,
              }
            ]
          },
        ],
      };

  if (props.values.values.movement_type == "import") {
    var validationSchema = yup.object().shape(
      {
        // order_number: yup.string().optional(),
        order_reference_no: yup.string().nullable().optional(),
        gross_weight: FEATURES.weightInTonCustomers ? 
        yup
          .number()
          .required("required")
          .min(1, "min")
          .when("net_weight", (net_weight) =>
            net_weight
              ? yup.number().optional().nullable().min(net_weight, "min_net").test('gross_weight', "invalid_gross_weight", value => AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value))
              : yup.number().required("required").min(1, "min").test('gross_weight', "invalid_gross_weight", value => AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value)).nullable()
          )
        :yup
          .number()
          .required("required")
          .min(1, "min")
          .when("net_weight", (net_weight) =>
            net_weight
              ? yup.number().optional().nullable().min(net_weight, "min_net")
              : yup.number().required("required").min(1, "min")
          ),
        net_weight: yup
          .number()
          .required("required")
          .min(1, "min")
          .when("gross_weight", (gross_weight) =>
            gross_weight
              ? yup
                .number()
                .optional()
                .nullable()
                .max(gross_weight, "max_gross")
              : yup.number().required("required").min(1, "min")
          ),
        proposed_vehicle_type: yup.number().required("required"),
        ownership_type_id: yup.number().optional().nullable(),
        booking_branch_id: yup.number().optional().nullable(),
        vehicle_number: yup.string().optional().nullable(),
        vendor_id: yup.number().optional(),
        freight_rate: yup.number().optional(),
        service_type_id: yup.number().optional(),
        load_type_id: yup.number().optional(),
        min_temp: yup
          .number()
          .optional()
          .nullable()
          .when("max_temp", (max_temp) =>
            max_temp
              ? yup.number().optional().nullable().max(max_temp, "max")
              : yup.number().optional().nullable()
          ),
        max_temp: yup
          .number()
          .optional()
          .nullable()
          .when("min_temp", (min_temp) =>
            min_temp
              ? yup.number().optional().nullable().min(min_temp, "min")
              : yup.number().optional().nullable()
          ),
        transaction_no : FEATURES.transactionDetailsEnabled ? yup
        .string()
        .optional()
        .nullable()
        .when("transaction_type_code", (transaction_type_code) =>
        transaction_type_code && transaction_type_code != TransactionTypes.OTHERS
            ? yup.string().required("required")
            : yup.string().optional().nullable()
        ) : yup
        .string()
        .optional()
        .nullable(),
        // transaction_amount : FEATURES.transactionDetailsEnabled ? yup
        // .string()
        // .optional()
        // .nullable()
        // .when("transaction_type_code", (transaction_type_code) =>
        // transaction_type_code && (transaction_type_code != TransactionTypes.OTHERS || transaction_type_code != TransactionTypes.SO)
        //     ? yup.string().required("required")
        //     : yup.string().optional().nullable()
        // ) : yup
        // .string()
        // .optional()
        // .nullable(),
        // transaction_quantity : FEATURES.transactionDetailsEnabled ? yup.string().required("required") : yup.string().optional().nullable(),
        deliveries: yup.array().of(
          yup.object().shape({
            delivery_number: yup.string().optional(),
            delivery_reference_no: yup.string().nullable().optional(),
            lr_no: yup.string().nullable().optional(),
            lr_date: yup.string().nullable().optional(),
            lr_date_t: yup.string().nullable().optional(),
            transporter_lr_no: yup.string().nullable().optional(),
            actual_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('actual_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
            gross_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('gross_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
            charged_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('charged_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
            grossWeightFlag: yup.boolean().nullable().optional(),
            chargedWeightFlag: yup.boolean().nullable().optional(),
            total_quantity: yup
              .number()
              .integer("Invalid Integer")
              .nullable()
              .optional(),
            booking_branch_id: yup.number().nullable().optional(),
            booking_branch_name: deliverOrderDetailsAccess && yup.string().required("required"),
            billing_branch_id: yup.number().nullable().optional(),
            insurance_no: yup.string().nullable().optional(),
            contractual_customer_id: FEATURES.contractualCustomerFieldEnabled ? yup
            .string()
            .optional()
            .nullable()
            .when("customer_type_id", (customer_type_id) =>
            customer_type_id && customer_type_id == 2
                ? yup.string().required("Required")
                : yup.string().optional().nullable()
            ) : yup
                .string()
                .optional()
                .nullable(),
            customer_type_id: yup.number().nullable().optional(),
            billing_party_id: yup.number().nullable().optional(),
            billing_party_branch_id: yup.number().nullable().optional(),
            deliver_to: yup.string().nullable().optional(),
            deliver_to_branch_id: yup.number().nullable().optional(),
            deliver_to_address: yup.string().nullable().optional(),
            remarks: yup.string().nullable().optional(),
            other: yup.string().nullable().optional(),
            consignor_code: yup.string().required("required"),
            consignee_code: yup.string().required("required"),
            pickup_area: yup.string().optional(),
            drop_area: yup.string().optional(),
            consignee_address: yup.string().nullable().optional(),
            consignor_address: yup.string().nullable().optional(),
            consignor_gstNumber: yup.string().nullable().optional(),
            consignee_gstNumber: yup.string().nullable().optional(),
            boarding_no: yup.string().optional().nullable(),
            import_declaration_no: yup.string().optional().nullable(),
            do_no: yup.string().nullable().optional(),
            do_validity_date: yup.string().nullable().optional(),
            do_validity_date_t: yup.string().nullable().optional(),
            proposed_freight_rate: yup.number().nullable().optional(),
            cft_kg_factor: yup.number().nullable().optional(),
            actual_freight_rate: yup.number().nullable().optional(),
            final_freight_rate: yup.number().nullable().optional(),
            final_rate: yup.number().nullable().optional(),
            uom: yup.string().nullable().optional(),
            container_no: yup.string().optional().nullable(),
            container_pickup_date: yup.string().optional().nullable(),
            container_pickup_date_t: yup.string().optional().nullable(),
            delivery_date: yup.string().optional().nullable(),
            delivery_date_t: yup.string().optional().nullable(),
            container_drop_location: yup.string().optional().nullable(),
            storage_expiration: yup.string().optional().nullable(),
            storage_expiration_t: yup.string().optional().nullable(),
            container_type: yup.string().optional().nullable(),
            container_type_id: yup.number().optional().nullable(),
            container_seal_no: yup.string().optional().nullable(),
            yard_id: yup.number().optional().nullable(),
            shipping_line_id: yup.number().optional().nullable(),
            cha_id: yup.number().optional().nullable(),
            demurrage_expiration: yup.string().optional().nullable(),
            demurrage_expiration_t: yup.string().optional().nullable(),
            ata_date: yup.string().optional().nullable().required("required"),
            products: yup.array().of(
              yup.object().shape({
                product_code: yup.string().optional().nullable(),
                product_name: yup.string().optional().nullable(),
                product_category_id: yup.number().optional().nullable(),
                packaging_type_id: yup.number().optional().nullable(),
                quantity: yup.number().optional().min(1, "min").nullable(),
                transaction_amount : FEATURES.transactionDetailsEnabled && yup.string().optional().nullable(),
                transaction_quantity : FEATURES.transactionDetailsEnabled && yup.string().optional().nullable(),
              })
            ),
            invoices: yup.array().of(
              yup.object().shape({
                invoice_code: yup.string().optional().nullable(),
                invoice_date: yup.string().optional().nullable(),
                invoice_quantity: yup
                  .number()
                  .optional()
                  .min(1, "min")
                  .nullable(),
                invoice_amount: yup.number().optional().nullable(),
                eway_bill_expirydate: yup.string().optional().nullable(),
                eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
              })
            ),
          })
        ),
      },
      [
        ["net_weight", "gross_weight"],
        ["max_temp", "min_temp"],
      ]
    );
  } else {
    var validationSchema = yup.object().shape(
      {
        order_reference_no: yup.string().nullable().optional(),
        gross_weight: FEATURES.weightInTonCustomers ? 
        yup
          .number()
          .required("required")
          .min(1, "min")
          .when("net_weight", (net_weight) =>
            net_weight
              ? yup.number().optional().nullable().min(net_weight, "min_net").test('gross_weight', "invalid_value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true)
              : yup.number().required("required").min(1, "min").test('gross_weight', "invalid_value", value => value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true).nullable()
          )
        : yup
          .number()
          .required("required")
          .min(1, "min")
          .when("net_weight", (net_weight) =>
            net_weight
              ? yup.number().optional().nullable().min(net_weight, "min_net")
              : yup.number().required("required").min(1, "min")
          ),
        net_weight: yup
          .number()
          .required("required")
          .min(1, "min")
          .when("gross_weight", (gross_weight) =>
            gross_weight
              ? yup
                .number()
                .optional()
                .nullable()
                .max(gross_weight, "max_gross")
              : yup.number().required("required").min(1, "min")
          ),
        min_temp: yup
          .number()
          .optional()
          .nullable()
          .when("max_temp", (max_temp) =>
            max_temp
              ? yup.number().optional().nullable().max(max_temp, "max")
              : yup.number().optional().nullable()
          ),
        max_temp: yup
          .number()
          .optional()
          .nullable()
          .when("min_temp", (min_temp) =>
            min_temp
              ? yup.number().optional().nullable().min(min_temp, "min")
              : yup.number().optional().nullable()
          ),
        transaction_no : FEATURES.transactionDetailsEnabled ? yup
        .string()
        .optional()
        .nullable()
        .when("transaction_type_code", (transaction_type_code) =>
        transaction_type_code && transaction_type_code != TransactionTypes.OTHERS
            ? yup.string().required("required")
            : yup.string().optional().nullable()
        ) : yup
        .string()
        .optional()
        .nullable(),
        // transaction_amount : FEATURES.transactionDetailsEnabled ? yup
        // .string()
        // .optional()
        // .nullable()
        // .when("transaction_type_code", (transaction_type_code) =>
        // transaction_type_code && (transaction_type_code != TransactionTypes.OTHERS || transaction_type_code != TransactionTypes.SO)
        //     ? yup.string().required("required")
        //     : yup.string().optional().nullable()
        // ) : yup
        // .string()
        // .optional()
        // .nullable(),
        // transaction_quantity : FEATURES.transactionDetailsEnabled ? yup.string().required("required") : yup.string().optional().nullable(),
        proposed_vehicle_type: yup.number().required("required"),
        //ownership_type_id: yup.number().optional().nullable(),
        booking_branch_id: yup.number().optional().nullable(),
        booking_branch_name: deliverOrderDetailsAccess && yup.string().required("required"),
        vendor_id: yup.number().optional(),
        ownership_type_id: yup.number().optional(),
        freight_rate: yup.number().optional(),
        service_type_id: yup.number().optional(),
        load_type_id: yup.number().optional(),
        deliveries: yup.array().of(
          yup.object().shape({
            delivery_number: yup.string().optional(),
            delivery_reference_no: yup.string().nullable().optional(),
            lr_no: yup.string().nullable().optional(),
            lr_date: yup.string().nullable().optional(),
            lr_date_t: yup.string().nullable().optional(),
            transporter_lr_no: yup.string().nullable().optional(),
            actual_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('actual_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
            gross_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('gross_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
            charged_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('charged_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
            grossWeightFlag: yup.boolean().nullable().optional(),
            chargedWeightFlag: yup.boolean().nullable().optional(),
            total_quantity: yup
              .number()
              .integer("Invalid Integer")
              .nullable()
              .optional(),
            booking_branch_id: yup.number().nullable().optional(),
            billing_branch_id: yup.number().nullable().optional(),
            insurance_no: yup.string().nullable().optional(),
            contractual_customer_id: FEATURES.contractualCustomerFieldEnabled ? yup
            .string()
            .optional()
            .nullable()
            .when("customer_type_id", (customer_type_id) =>
            customer_type_id && customer_type_id == 2
                ? yup.string().required("Required")
                : yup.string().optional().nullable()
            ) : yup
                .string()
                .optional()
                .nullable(),
            customer_type_id: yup.number().nullable().optional(),
            billing_party_id:
              FEATURES.billingPartyAndBranchRequiredInCreateOrder
                ? yup.string().nullable().required("Required")
                : yup.number().nullable().optional(),
            billing_party_branch_id:
              FEATURES.billingPartyAndBranchRequiredInCreateOrder
                ? yup.string().nullable().required("Required")
                : yup.number().nullable().optional(),
            deliver_to: yup.string().nullable().optional(),
            deliver_to_branch_id: yup.number().nullable().optional(),
            deliver_to_address: yup.string().nullable().optional(),
            other: yup.string().nullable().optional(),
            remarks: yup.string().nullable().optional(),
            consignor_code: yup.string().required("required"),
            consignee_code: yup.string().required("required"),
            pickup_area: yup.string().optional(),
            drop_area: yup.string().optional(),
            consignee_address: yup.string().nullable().optional(),
            consignor_address: yup.string().nullable().optional(),
            consignor_gstNumber: yup.string().nullable().optional(),
            consignee_gstNumber: yup.string().nullable().optional(),
            boarding_no: yup.string().optional().nullable(),
            import_declaration_no: yup.string().optional().nullable(),
            do_no: yup.string().nullable().optional(),
            do_validity_date: yup.string().nullable().optional(),
            do_validity_date_t: yup.string().nullable().optional(),
            proposed_freight_rate: yup.number().nullable().optional(),
            cft_kg_factor: yup.number().nullable().optional(),
            actual_freight_rate: yup.number().nullable().optional(),
            final_freight_rate: yup.number().nullable().optional(),
            final_rate: yup.number().nullable().optional(),
            uom: yup.string().nullable().optional(),
            container_no: yup.string().optional().nullable(),
            container_pickup_date: yup.string().optional().nullable(),
            container_pickup_date_t: yup.string().optional().nullable(),
            delivery_date: yup.string().optional().nullable(),
            delivery_date_t: yup.string().optional().nullable(),
            container_drop_location: yup.string().optional().nullable(),
            storage_expiration: yup.string().optional().nullable(),
            container_type: yup.string().optional().nullable(),
            container_type_id: yup.number().optional().nullable(),
            container_seal_no: yup.string().optional().nullable(),
            yard_id: yup.number().optional().nullable(),
            shipping_line_id: yup.number().optional().nullable(),
            cha_id: yup.number().optional().nullable(),
            demurrage_expiration: yup.string().optional().nullable(),
            ata_date: yup.string().optional().nullable(),
            products: yup.array().of(
              yup.object().shape({
                product_code: yup.string().optional().nullable(),
                product_name: yup.string().optional().nullable(),
                product_category_id: yup.number().optional().nullable(),
                packaging_type_id: yup.number().optional().nullable(),
                quantity: yup.number().optional().min(1, "min").nullable(),
                // quantity: yup.number().required("required").min(1, "min"),
                transaction_amount : FEATURES.transactionDetailsEnabled && yup.string().optional().nullable(),
                transaction_quantity : FEATURES.transactionDetailsEnabled && yup.string().optional().nullable(),
              })
            ),
            invoices: yup.array().of(
              yup.object().shape({
                invoice_code: yup.string().optional().nullable(),
                invoice_date: yup.string().optional().nullable(),
                invoice_quantity: yup
                  .number()
                  .optional()
                  .min(1, "min")
                  .nullable(),
                invoice_amount: yup.number().optional().nullable(),
                eway_bill_expirydate: yup.string().optional().nullable(),
                eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
              })
            ),
          })
        ),
      },
      [
        ["net_weight", "gross_weight"],
        ["max_temp", "min_temp"],
      ]
    );
  }

  const getBillingPartySelected = (billingPartyId) => {
    if (billingPartyId) {
      let token = LOCAL_STORAGE.userToken
      let userId = LOCAL_STORAGE.userId
      let customerNo = LOCAL_STORAGE.customerNo
      let billingPartyBranchIds = LOCAL_STORAGE.billing_Party_Branch_Ids?.toString();

      Axios.get(
        `${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchIds=${billingPartyBranchIds}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      )
        .then((response) => {
          setBillingPartyBranch(response.data.resultSet);
        })
        .catch((error) => console.log(error));

      Axios.get(
        `${process.env.REACT_APP_MASTER_API}mappings/consignee_billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      )
        .then((response) => {
          setConsigneeArray(response.data.resultSet);
        })
        .catch((error) => console.log(error));
    } else {
      setBillingPartyBranch([]);
    }
  };

  const getConsigneeConsignorArray = (billingPartyId, billingPartyBranchId) => {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}mappings/consignor_billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchId=${billingPartyBranchId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setConsignorArray(response.data.resultSet);
      })
      .catch((error) => console.log(error));
  };

  const getCounts = (arr) => {
    let sum = arr && arr?.reduce(function (sum, elem) {
      return sum + elem?.quantity;
    }, 0)
    if (sum != false) {
      return sum
    } else {
      return 0
    }
  }

  const getContainerSizeArray = () => {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}/container_size?customerNumber=${customerNo}&userId=${userId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        let containerData = response.data.resultSet;
        setContainerSizeList(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.containerSize,
              name: item.containerSizeCode,
              value: item.containerSizeCode,
              raw: { ...item },
            };
          })
        );
      })
      .catch((error) => console.log(error));
  };

  return (
    <div>

      <Modal
        open={props.OpenModel}
        size="fullscreen"
        centered={false}
        scrolling="true"
        onClose={props.handleClose}
      >
        <Modal.Header className="p-bold-100">
          {FEATURES.orderPageHeadingAsBookingDetails ? "All Booking Details" : props.t("title") || "Add Order Details"}
        </Modal.Header>
        <Formik
          validationSchema={validationSchema}
          initialValues={decideInitialValue}
          onSubmit={(values) => {
            let orders = [];
            let shipments = props.shipment;

            //validation for transaction_details
            if(FEATURES.transactionDetailsEnabled && values?.transaction_type_code){
              if(values?.transaction_type_code===TransactionTypes.PO || values?.transaction_type_code===TransactionTypes.STO || values?.transaction_type_code===TransactionTypes.SO){
                values.cost_center_code = ''
              }
            }
            values.gross_weight = values.gross_weight && Number(values?.gross_weight);
            if(values.deliveries.length){
              for(let delivery of values.deliveries){
                delivery.actual_weight = delivery.actual_weight && Number(delivery.actual_weight);
                delivery.gross_weight = delivery.gross_weight && Number(delivery.gross_weight);
                delivery.charged_weight = delivery.charged_weight && Number(delivery.charged_weight);
              }
            }
            if (props.editOrderIndex !== null) {
              if (values.vendor_id == "") {
                values.vendor_id = 0;
              }
              if (values.deliveries.length > 1) {
                for (let index = 0; index < values.deliveries.length; index++) {

                  if (values.deliveries[index].lr_other_charges[0].charge_type_id == null || '' && values.deliveries[index].lr_other_charges[0].charges == null || '') {
                    values.deliveries[index].lr_other_charges = []
                  }
                  if (values.deliveries[index].invoices.length != 0) {
                    if (
                      values.deliveries[index].invoices[0].bl_no == null &&
                      values.deliveries[index].invoices[0].invoice_amount ==
                      null &&
                      values.deliveries[index].invoices[0].invoice_date ==
                      null &&
                      values.deliveries[index].invoices[0].invoice_no == null &&
                      values.deliveries[index].invoices[0].eway_bill_no == null &&
                      values.deliveries[index].invoices[0].eway_bill_expirydate == null &&
                      values.deliveries[index].invoices[0].invoice_quantity ==
                      null
                    ) {
                      values.deliveries[index].invoices = [];
                    }
                  }
                  if (values.deliveries[index].products.length != 0) {
                    if (
                      values.deliveries[index].products[0].product_code ==
                      null &&
                      values.deliveries[index].products[0].product_name ==
                      null &&
                      values.deliveries[index].products[0]
                        .product_category_id == null &&
                      values.deliveries[index].products[0].packaging_type_id ==
                      null &&
                      values.deliveries[index].products[0].quantity == null
                    ) {
                      values.deliveries[index].products = [];
                    }
                  }
                }
              }
              // need to update the order
              shipments.create.orders.splice(props.editOrderIndex, 1, values);
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody: "Order is updated.",
              });
            } else {
              if (
                shipments &&
                shipments.create.orders &&
                shipments.create.orders.length > 0
              ) {
                if (values.vendor_id == "") {
                  values.vendor_id = 0;
                }
                for (let index = 0; index < values.deliveries.length; index++) {
                  if ((values.deliveries?.[index]?.lr_other_charges?.[0]?.charge_type_id == null) && (values.deliveries?.[index]?.lr_other_charges?.[0]?.charges == null)) {
                    values.deliveries[index].lr_other_charges = []
                  }
                  if (values.deliveries[index].invoices.length != 0) {
                    if (
                      values.deliveries[index].invoices[0].bl_no == null &&
                      values.deliveries[index].invoices[0].invoice_amount ==
                      null &&
                      values.deliveries[index].invoices[0].invoice_date ==
                      null &&
                      values.deliveries[index].invoices[0].invoice_no == null &&
                      values.deliveries[index].invoices[0].eway_bill_no == null &&
                      values.deliveries[index].invoices[0].eway_bill_expirydate == null &&
                      values.deliveries[index].invoices[0].invoice_quantity ==
                      null
                    ) {
                      values.deliveries[index].invoices = [];
                    }
                  }

                  if (values.deliveries[index].products.length != 0) {
                    if (
                      values.deliveries[index].products[0].product_code ==
                      null &&
                      values.deliveries[index].products[0].product_name ==
                      null &&
                      values.deliveries[index].products[0]
                        .product_category_id == null &&
                      values.deliveries[index].products[0].packaging_type_id ==
                      null &&
                      values.deliveries[index].products[0].quantity == null
                    ) {
                      values.deliveries[index].products = [];
                    }
                  }
                }
                shipments.create.orders.push(values);
              } else {
                if (values.vendor_id == "") {
                  values.vendor_id = 0;
                }
                if (values.deliveries.length > 1) {
                  for (
                    let index = 0;
                    index < values.deliveries.length;
                    index++
                  ) {
                    if ((values.deliveries?.[index]?.lr_other_charges?.[0]?.charge_type_id == null) && (values.deliveries?.[index]?.lr_other_charges?.[0]?.charges == null)) {
                      values.deliveries[index].lr_other_charges = []
                    }
                    if (
                      values.deliveries[index].invoices[0].bl_no == null &&
                      values.deliveries[index].invoices[0].invoice_amount ==
                      null &&
                      values.deliveries[index].invoices[0].invoice_date ==
                      null &&
                      values.deliveries[index].invoices[0].invoice_no == null &&
                      values.deliveries[index].invoices[0].eway_bill_no == null &&
                      values.deliveries[index].invoices[0].eway_bill_expirydate == null &&
                      values.deliveries[index].invoices[0].invoice_quantity ==
                      null
                    ) {
                      values.deliveries[index].invoices = [];
                    }
                    if (
                      values.deliveries[index].products[0].product_code ==
                      null &&
                      values.deliveries[index].products[0].product_name ==
                      null &&
                      values.deliveries[index].products[0]
                        .product_category_id == null &&
                      values.deliveries[index].products[0].packaging_type_id ==
                      null &&
                      values.deliveries[index].products[0].quantity == null
                    ) {
                      values.deliveries[index].products = [];
                    }
                  }
                }
                orders.push(values);
                for (let index = 0; index < orders.length; index++) {
                  if ((values.deliveries?.[index]?.lr_other_charges?.[0]?.charge_type_id == null) && (values.deliveries?.[index]?.lr_other_charges?.[0]?.charges == null)) {
                    values.deliveries[index].lr_other_charges = []
                  }
                  if (orders[index].deliveries[index].invoices.length != 0) {
                    if (
                      orders[index].deliveries[index].invoices[0].bl_no ==
                      null &&
                      orders[index].deliveries[index].invoices[0]
                        .invoice_amount == null &&
                      orders[index].deliveries[index].invoices[0]
                        .invoice_date == null &&
                      orders[index].deliveries[index].invoices[0].invoice_no ==
                      null &&
                      orders[index].deliveries[index].invoices[0].eway_bill_no ==
                      null &&
                      orders[index].deliveries[index].invoices[0].eway_bill_expirydate ==
                      null &&
                      orders[index].deliveries[index].invoices[0]
                        .invoice_quantity == null
                    ) {
                      orders[index].deliveries[index].invoices = [];
                    }
                  }
                }



                for (let index = 0; index < orders.length; index++) {
                  if (orders[index].deliveries[index].products.length > 0) {
                    if (
                      (orders[index].deliveries[index].products[0]
                        .product_code == null ||
                        orders[index].deliveries[index].products[0]
                          .product_code == "") &&
                      (orders[index].deliveries[index].products[0]
                        .product_name == null ||
                        orders[index].deliveries[index].products[0]
                          .product_name == "") &&
                      (orders[index].deliveries[index].products[0]
                        .product_category_id == null ||
                        orders[index].deliveries[index].products[0]
                          .product_category_id == "") &&
                      (orders[index].deliveries[index].products[0]
                        .packaging_type_id == null ||
                        orders[index].deliveries[index].products[0]
                          .packaging_type_id == "") &&
                      (orders[index].deliveries[index].products[0].quantity ==
                        null ||
                        orders[index].deliveries[index].products[0].quantity ==
                        "")
                    ) {
                      orders[index].deliveries[index].products = [];
                    }
                  }
                }
                shipments = Object.assign({}, props.shipment.create, {
                  orders,
                });
              }
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody: "New order is created.",
              });
            }
            shipments = shipments.create
              ? { ...shipments.create }
              : { ...shipments };
            props.createShipmentDispatcher(shipments, false);
            props.handleClose();


          }}
          render={({ values, setFieldValue, errors, touched, t }) => {
            const setProductCodeAndProductName = (name, data, productname) => {
              setFieldValue(data.name, data.value);
              setFieldValue(
                productname,
                data.options.find((ele) => ele.value == data.value)
                  ? data.options.find((ele) => ele.value == data.value).raw
                    .skuName
                  : ""
              );
            };
            return (
              <Modal.Content
                size="fullscreen"
                style={{ maxHeight: "100%" }}
                scrolling={true}
              >
                <Modal.Description>
                  <Formiker className="ui form tiny">
                    <FormUi.Group>
                      <FormUi.Field
                        width={3}
                        error={
                          touched.proposed_vehicle_type &&
                            errors.proposed_vehicle_type
                            ? true
                            : false
                        }
                      >
                        <label className="labelName mt-2">
                          {props.t("proposed_vehicle_type.title") ||
                            "Proposed Vehicle Type"}{" "}
                          <MandatoryMark />
                        </label>
                        <Dropdown
                          clearable
                          name="proposed_vehicle_type"
                          style={{ width: "100%", fontWeight: "normal" }}
                          search
                          selection
                          placeholder={
                            values?.proposed_vehicle_type_name ? values?.proposed_vehicle_type_name :
                              props.t("proposed_vehicle_type.placeholder") ||
                              "Proposed Vehicle Type"
                          }
                          onChange={(name, data) => {
                            setFieldValue("proposed_vehicle_type", data.value)
                            if (data?.options && data?.options?.length > 0) {
                              data.options.forEach(element => {
                                if (element.value == data.value) {
                                  setFieldValue("proposed_vehicle_type_name", element.text)
                                }
                              });
                            }
                          }
                          }
                          options={vehicles}
                        />
                        {touched.proposed_vehicle_type &&
                          errors.proposed_vehicle_type ? (
                          <div className="w3-small w3-text-red">
                            {props.t(
                              `proposed_vehicle_type.error_msg.${errors.proposed_vehicle_type}`
                            ) || errors.proposed_vehicle_type}
                          </div>
                        ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field
                        width={3}
                        error={touched.vendor && errors.vendor ? true : false}
                      >
                        <label className="labelName mt-2">
                          {props.t("vendor.title") || "Vendor"}{" "}
                        </label>
                        {checkowner == 1 ? (
                          <Dropdown
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            search
                            selection
                            placeholder={
                              props.t("vendor.placeholder") || "Select Vendor"
                            }
                            defaultValue={values.vendor_id}
                            onChange={(name, data) =>
                              setFieldValue("vendor_id", data.value)
                            }
                            options={ownvendor}
                          />
                        ) : (
                          <>
                            <Fieldmik
                              name={"vendor_id"}
                              placeholder={
                                values.vendor_name != ""
                                  ? values.vendor_name
                                  : props.t("vendor.placeholder") ||
                                  "Select Vendor"
                              }
                              component={MyVendorComponent}
                            />
                          </>
                        )}

                        {touched.vendor && errors.vendor ? (
                          <div className="w3-small w3-text-red">
                            {props.t(`vendor.error_msg.${errors.vendor}`) ||
                              errors.vendor}
                          </div>
                        ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field
                        width={3}
                        error={
                          touched.gross_weight && errors.gross_weight
                            ? true
                            : false
                        }
                      >
                        <label className="labelName mt-2">
                          {(FEATURES.weightInTonCustomers ? props.t("gross_weight.title_ton") : props.t("gross_weight.title")) || "Gross Weight"}
                          {"*"}
                        </label>
                        <Fieldmik
                          component={MyNormalInput}
                          name="gross_weight"
                          type={FEATURES.weightInTonCustomers ? "text" : "number"}
                          onChange={(e)=>{
                            setFieldValue("gross_weight", e?.target?.value)
                          }}
                          min={0}
                        />
                        {touched.gross_weight && errors.gross_weight ? (
                          <div className="w3-text-red w3-tiny">
                            {props.t(
                              `gross_weight.error_msg.${errors.gross_weight}`
                            ) || errors.gross_weight}
                          </div>
                        ) : null}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      {!FEATURES.createOrderhideFields ? (
                        <>
                          <FormUi.Field
                            width={3}
                            error={
                              touched.ownership_type_id &&
                                errors.ownership_type_id
                                ? true
                                : false
                            }
                          >
                            <label className="labelName mt-2">
                              {props.t("ownership_type.title") ||
                                "Vehicle Ownership Type"}{" "}
                            </label>
                            <Dropdown
                              clearable
                              style={{ width: "100%", fontWeight: "normal" }}
                              search
                              selection
                              name="ownership_type_id"
                              placeholder={
                                props.t("ownership_type.placeholder") ||
                                "Vehicle Ownership Type"
                              }
                              defaultValue={values.ownership_type_id}
                              onChange={(name, data) => {
                                setFieldValue("ownership_type_id", data.value);
                                checkOwnership(data);
                              }}
                              options={ownership}
                            />
                            {touched.ownership_type_id &&
                              errors.ownership_type_id ? (
                              <div className="w3-small w3-text-red">
                                {props.t(
                                  `ownership_type.error_msg.${errors.ownership_type_id}`
                                ) || errors.ownership_type_id}
                              </div>
                            ) : null}
                          </FormUi.Field>
                        </>
                      ) : null}
                      {/* <FormUi.Field width={1} /> */}

                      {props.moment == "primary" ? (
                        <>
                          {/* <FormUi.Field
                            width={3}
                            // className="m-0 mb-2"
                            error={
                              touched.service_type_id && errors.service_type_id
                                ? true
                                : false
                            }
                          >
                            <label className="labelName mt-2"
                              style={{ whiteSpace: "nowrap" }}>
                              {props.t("service_type.title") || "Service Types"}{" "}
                            </label>
                            <Dropdown
                              clearable
                              style={{ width: "100%", fontWeight: "normal" }}
                              search
                              loading={isloading}
                              selection
                              placeholder={
                                props.t("service_type.placeholder") ||
                                "Service Type"
                              }
                              defaultValue={values.service_type_id}
                              onChange={(name, data) =>
                                setFieldValue("service_type_id", data.value)
                              }
                              options={service}
                            />
                            {touched.service_type_id &&
                              errors.service_type_id ? (
                              <div className="w3-small w3-text-red">
                                {props.t(
                                  `service_type.error_msg.${errors.service_type}`
                                ) || errors.service_type}
                              </div>
                            ) : null}
                          </FormUi.Field> */}
                          <FormUi.Field width={1} />
                          <FormUi.Field
                            width={3}
                            error={
                              touched.load_type_id && errors.load_type_id
                                ? true
                                : false
                            }
                          >
                            <label className="labelName mt-2">
                              {props.t("load_type.title") || "Load Type"}{" "}
                            </label>
                            <Dropdown
                              clearable
                              style={{ width: "100%", fontWeight: "normal" }}
                              search
                              loading={isloading}
                              selection
                              placeholder={
                                props.t("load_type.placeholder") || "Load Type"
                              }
                              defaultValue={values.load_type_id}
                              onChange={(name, data) =>
                                setFieldValue("load_type_id", data.value)
                              }
                              options={load}
                            />
                            {touched.load_type_id && errors.load_type_id ? (
                              <div className="w3-small w3-text-red">
                                {props.t(
                                  `load_type.error_msg.${errors.load_type}`
                                ) || errors.load_type}
                              </div>
                            ) : null}
                          </FormUi.Field>
                        </>
                      ) : null}


                      <FormUi.Field width={1} />
                      <FormUi.Field
                        width={3}

                      >
                        <label className="labelName mt-2">
                          {(FEATURES.weightInTonCustomers ? props.t("delivery_form.actual_weight.title_ton") : props.t("delivery_form.actual_weight.title")) || "Actual Weight"}
                          {"*"}
                        </label>
                        <Fieldmik
                          component={MyNormalInput}
                          value={values?.deliveries.reduce((actualVal, object) => {
                            let actual_weight_value = object?.actual_weight || 0 ;
                            return parseFloat(actualVal) + parseFloat(actual_weight_value)
                          }, 0)}
                          type={FEATURES.weightInTonCustomers ? "text" : "number"}
                          readOnly

                        />

                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      {/* <FormUi.Field width={2} /> */}
                      {values.vendor_id &&
                        values.ownership_type_id &&
                        values.ownership_type_id == 2 ? (
                        <>
                          <FormUi.Field
                            width={3}
                            error={
                              touched.freight_rate && errors.freight_rate
                                ? true
                                : false
                            }
                          >
                            <label className="labelName mt-2">
                              {props.t("final_rate.title") || "Final Rate"}{" "}
                              {/* <MandatoryMark /> */}
                            </label>
                            <Fieldmik
                              component={MyNormalInput}
                              type="number"
                              name="freight_rate"
                            />
                            {touched.freight_rate && errors.freight_rate ? (
                              <div className="w3-text-red w3-tiny">
                                {props.t(
                                  `final_rate.error_msg.${errors.freight_rate}`
                                ) || errors.freight_rate}
                              </div>
                            ) : null}
                          </FormUi.Field>
                        </>
                      ) : (
                        <>
                          {values.ownership_type_id == 1 && values.vendor_id ? (
                            <>
                              <FormUi.Field
                                width={3}
                                error={
                                  touched.gross_weight && errors.gross_weight
                                    ? true
                                    : false
                                }
                              >
                                <label className="labelName mt-2">
                                  {props.t("vehicle_no.title") ||
                                    "Vehicle Number"}
                                </label>
                                <SearchDropdown
                                  setField={(name, value) => {
                                    if (value?.raw?.vehicleTypeId) {
                                      setFieldValue("proposed_vehicle_type", value.raw.vehicleTypeId)
                                      setFieldValue("proposed_vehicle_type_name", value.raw.vehicleType)
                                    }
                                    setFieldValue(
                                      "vehicle_number",
                                      value.raw
                                        ? value.raw.vehicleNumber
                                        : value
                                    )
                                  }
                                  }
                                  masterRoute={
                                    "vendorMaster/vehicles/" + values.vendor_id
                                  }
                                  masterRouteKey="vehicleId"
                                  masterRouteName="vehicleNumber"
                                  fieldName="vehicle_number"
                                />
                              </FormUi.Field>
                            </>
                          ) : null}
                        </>
                      )}
                    </FormUi.Group>

                    <FormUi.Group>
                      {values.load_type_id == "3" ||
                        values.load_type_id == "2" ||
                        values.load_type_id == "1" ? (
                        <>
                          <FormUi.Field
                            width={3}
                            error={
                              touched.min_temp && errors.min_temp ? true : false
                            }
                          >
                            <label className="labelName mt-2">
                              {props.t("delivery_form.temperature_min.title") ||
                                "Temperature Minimum"}
                            </label>
                            <Fieldmik
                              component={MyNumInput}
                              className="placeholder-black"
                              type="number"
                              icon="thermometer quarter"
                              iconPosition="left"
                              style={{ paddingTop: "5.5px" }}
                              name="min_temp"
                              placeholder={
                                values.min_temp
                                  ? values.min_temp
                                  : "Minimum temperature"
                              }
                              error={
                                getIn(errors, `min_temp`) &&
                                  getIn(touched, `min_temp`)
                                  ? true
                                  : false
                              }
                            />
                            {
                              <ErrorMessages
                                name={`min_temp`}
                                trans={"delivery_form.temperature_min"}
                              />
                            }
                          </FormUi.Field>
                          <FormUi.Field width={1} />
                          <FormUi.Field
                            width={3}
                            error={
                              touched.max_temp && errors.max_temp ? true : false
                            }
                          >
                            <label className="labelName mt-2">
                              {props.t("delivery_form.temperature_max.title") ||
                                "Temperature Maximum"}
                            </label>
                            <Fieldmik
                              component={MyNumInput}
                              type="number"
                              className="placeholder-black"
                              icon="thermometer quarter"
                              iconPosition="left"
                              style={{ paddingTop: "5.5px" }}
                              name={`max_temp`}
                              placeholder={
                                values.max_temp
                                  ? values.max_temp
                                  : "Maximum temperature"
                              }
                              error={
                                getIn(errors, `max_temp`) &&
                                  getIn(touched, `max_temp`)
                                  ? true
                                  : false
                              }
                            />
                            {
                              <ErrorMessages
                                name={`max_temp`}
                                trans={"delivery_form.temperature_max"}
                              />
                            }
                          </FormUi.Field>
                          <FormUi.Field width={1} />
                        </>
                      ) : null}
                      {FEATURES.createOrderhideFields ? null : (
                        <FormUi.Field
                          width={3}
                          error={
                            touched.service_type_id && errors.service_type_id
                              ? true
                              : false
                          }
                        >
                          <label className="labelName mt-2">
                            {props.t("booking_branch.title") ||
                              "Booking Branch"}{" "}
                          </label>
                          <Dropdown
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            search
                            loading={isloading}
                            selection
                            placeholder={
                              values.booking_branch_name
                                ? values.booking_branch_name
                                : props.t("booking_branch.placeholder") ||
                                "Booking Branch"
                            }
                            onChange={(name, data) => {
                              data.options.map((item, o) => {
                                if (item.raw.branchId == data.value) {
                                  setFieldValue(
                                    "booking_branch_name",
                                    item.raw.branchName
                                  );
                                }
                              });
                              setFieldValue("booking_branch_id", data.value);
                            }}
                            options={userbranchs}
                          />
                          {touched.service_type_id && errors.service_type_id ? (
                            <div className="w3-small w3-text-red">
                              {props.t(
                                `service_type.error_msg.${errors.service_type}`
                              ) || errors.service_type}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      )}

                      {FEATURES.createOrderShowModeOfTransport ?
                        <FormUi.Field width={1} /> : null
                      }

                      {!FEATURES.createOrderShowModeOfTransport ? null : (
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {props.t("Mode of Transport") ||
                              "Mode of Transport"}
                          </label>
                          <Fieldmik
                            component={ModeOfTransportDropdown}
                            name="mode_of_transport"
                            defaultValue={values.mode_of_transport}
                          />
                        </FormUi.Field>
                      )}

                      {FEATURES.createOrderShowModeOfTransport || !FEATURES.createOrderhideFields ?
                        <FormUi.Field width={1} /> : null
                      }

                      <FormUi.Field
                        width={3}
                        error={
                          touched.service_type_id && errors.service_type_id
                            ? true
                            : false
                        }
                      >
                        <label className="labelName mt-2">
                          {props.t("reference_number.title") ||
                            "Order Reference Number"}{" "}
                        </label>
                        <Fieldmik
                          component={MyInput}
                          name="order_reference_no"
                          className="placeholder-black"
                          style={{ width: "100%", fontWeight: "normal" }}
                          placeholder={values?.order_reference_no ? values.order_reference_no : props.t(
                            "reference_number.title"
                          )}
                        />
                      </FormUi.Field>
                    </FormUi.Group>


                      {
                            FEATURES.transactionDetailsEnabled &&
                            <>
                            <Table>
                            <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell colSpan="18">SAP Integration Fields</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                            <Table.Row>
                            <Table.Cell colSpan="4">
                            <FormUi.Group>
                            <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("transaction_type.title") ||
                            "Transaction Type"}{" "}
                        </label>
                        <Fieldmik
                          component={MyTransactionTypes}
                          name="transaction_type_code"
                          className="placeholder-black"
                          placeholder={props.t(
                            "transaction_type.placeholder"
                          )}
                          value={values?.transaction_type_code || ""}
                        />
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("transaction_no.title") ||
                            "Transaction Number"}{" "}
                        </label>
                        <Fieldmik
                          component={MyInput}
                          name="transaction_no"
                          className="placeholder-black"
                          placeholder={props.t(
                            "transaction_no.placeholder"
                          )}
                          value={values?.transaction_no || ""}
                        />
                        {errors.transaction_no ? (
                          <div className="w3-small w3-text-red">
                            {errors.transaction_no}
                          </div>
                        ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      {/* <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("transaction_amount.title") ||
                            "Transaction Amount"}{" "}
                        </label>
                        <Fieldmik
                          component={MyInput}
                          name="transaction_amount"
                          className="placeholder-black"
                          placeholder={props.t(
                            "transaction_amount.placeholder"
                          )}
                          value={values?.transaction_amount || ""}
                        />
                        {errors.transaction_amount ? (
                          <div className="w3-small w3-text-red">
                            {errors.transaction_amount}
                          </div>
                        ) : null}
                      </FormUi.Field> */}
                      <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("company.title") ||
                            "Company"}{" "}
                        </label>
                        <Fieldmik
                          component={MyCompanyCode}
                          name="company_code"
                          className="placeholder-black"
                          placeholder={props.t(
                            "company.placeholder"
                          )}
                          value={values?.company_code || ""}
                        />
                      </FormUi.Field>
                      </FormUi.Group>
                      </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                      <Table.Cell colSpan="4">
                      <FormUi.Group>
                      {/* <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("transaction_quantity.title") ||
                            "Transaction Quantity"}{" "}
                        </label>
                        <Fieldmik
                          component={MyInput}
                          type="number"
                          name="transaction_quantity"
                          className="placeholder-black"
                          placeholder={props.t(
                            "transaction_quantity.placeholder"
                          )}
                          value={values?.transaction_quantity || ""}
                        />
                        {errors.transaction_quantity ? (
                          <div className="w3-small w3-text-red">
                            {errors.transaction_quantity}
                          </div>
                        ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={1} /> */}
                      
                      <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("gl_code.title") ||
                            "GL Code"}{" "}
                        </label>
                        <Fieldmik
                          component={MyGLCode}
                          name="gl_code"
                          transactionType={values?.transaction_type_code||""}
                          className="placeholder-black"
                          placeholder={props.t(
                            "gl_code.placeholder"
                          )}
                          value={values?.gl_code || ""}
                        />
                    
                      </FormUi.Field> 
                      <FormUi.Field width={1} />
                      <FormUi.Field
                        width={5}
                      >
                        <label className="labelName mt-2">
                          {props.t("cost_center.title") ||
                            "Cost Center"}{" "}
                        </label>
                        {values?.transaction_type_code && 
                          (values?.transaction_type_code===TransactionTypes.PO || values?.transaction_type_code===TransactionTypes.STO || values?.transaction_type_code===TransactionTypes.SO) ? 
                          <>
                          <Fieldmik
                          component={MyInput}
                          name="cost_center_code"
                          placeholder={props.t(
                            "cost_center.placeholder"
                          )}
                          disabled={true}
                        /> 
                        </>: 
                        <Fieldmik
                          component={MyCostCenter}
                          name="cost_center_code"
                          className="placeholder-black"
                          placeholder={props.t(
                            "cost_center.placeholder"
                          )}
                          value={values?.cost_center_code || ""}
                        />}
                      </FormUi.Field> 
                      <FormUi.Field width={6} />
                      </FormUi.Group>
                      </Table.Cell>
                      </Table.Row>

                      
                            </Table.Body>
                            </Table>
                            </>
                          }
                    <FieldArray
                      name="deliveries"
                      render={(arrayHelpers) => (
                        <>
                          {values.deliveries.map((object, index) => (
                            <Table unstackable key={`delivery_form` + index}>
                              { }
                              <Table.Header>
                                <Table.Row>
                                  <Table.HeaderCell colSpan="1">
                                    {props.t("delivery_form.title") ||
                                      "Delivery"}{" "}
                                    {index + 1}
                                  </Table.HeaderCell>
                                  <Table.HeaderCell colSpan="1"></Table.HeaderCell>
                                  <Table.HeaderCell colSpan="1"></Table.HeaderCell>
                                  <Table.HeaderCell
                                    colSpan="1"
                                    textAlign="right"
                                  >
                                    <Button
                                      hidden={index === 0 ? true : false}
                                      size="mini"
                                      basic
                                      color="red"
                                      onClick={() => arrayHelpers.remove(index)}
                                      icon
                                    >
                                      <Icon name="trash" />{" "}
                                      {props.t("delivery_form.title") ||
                                        "Delivery"}
                                    </Button>
                                  </Table.HeaderCell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                {!FEATURES.createOrderhideFields ?
                                  <>
                                    <Table.Row>
                                      <Table.Cell colSpan="4">
                                        <FormUi.Group>
                                          <FormUi.Field
                                            width={5}

                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {values.ownership_type_id == 2
                                                ? props.t(
                                                  "delivery_form.transporter_lr_no.title"
                                                ) || "LR No"
                                                : props.t(
                                                  "delivery_form.transporter_lr_no.title"
                                                ) || "LR No"
                                              }
                                            </label>
                                          {/* </FormUi.Field>

                                          <FormUi.Field width={3}> */}
                                            <Fieldmik
                                              component={MyInput}
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                              value={
                                                values.deliveries[index].lr_no
                                              }
                                              name={`deliveries[${index}].lr_no`}
                                              readOnly={ FEATURES.lr_series_fixed_customer ? values?.vendor_name && FEATURES.lr_series_fixed(values.vendor_name) && values.deliveries[index].is_lr_generated_by_lr_series : values.deliveries[index].is_lr_generated_by_lr_series}
                                            />
                                            {console.log(values.vendor_name,'rowdata>>>>')}
                                          </FormUi.Field>

                                          <FormUi.Field width={1} />
                                          <FormUi.Field
                                            width={5}

                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {values.ownership_type_id == 2
                                                ? props.t(
                                                  "delivery_form.transporter_lr_date.title"
                                                ) || "Vendor LR date"
                                                : props.t(
                                                  "delivery_form.transporter_lr_date.title"
                                                ) || "LR date"}
                                            </label>
                                          {/* </FormUi.Field>

                                          <FormUi.Field width={3}> */}
                                            <DateData
                                              name={`deliveries[${index}].lr_date_t`}
                                              tname={`deliveries[${index}].lr_date`}
                                              autoComplete="off"
                                              timeFormat="HH:mm"
                                              popperClassName="dateTime"
                                              dateFormat="dd/MM/yyyy HH:mm"
                                              timeIntervals={5}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                          </FormUi.Field>
                                          <FormUi.Field width={6} />
                                        </FormUi.Group>
                                      </Table.Cell>
                                    </Table.Row>
                                  </> : null}

                                {FEATURES.createOrderBillingPartySeparateComponent ? (
                                  <>
                                    <Table.Row>

                                      <Table.Cell colSpan="4">
                                        <FormUi.Group>

                                          <FormUi.Field
                                            width={2}
                                          >
                                            <label
                                              className="labelName"
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {props.t(
                                                "delivery_form.billing_party.title"
                                              ) || "Billing Party"}{" "}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Fieldmik
                                              name={`deliveries[${index}].billing_party_id`}
                                              defaultValue={
                                                values.deliveries[index]
                                                  .billing_party_id
                                              }
                                              placeholder={
                                                props.t(
                                                  "delivery_form.billing_party.placeholder"
                                                ) || "Billing Party"
                                              }
                                              component={
                                                MyBillingPartyComponent
                                              }
                                              onChange={(name, data) => {
                                                setFieldValue(
                                                  `deliveries[${index}].billing_party_id`,
                                                  +data.value
                                                );
                                                let billing_party_raw = data?.options?.find((obj)=> obj.value == data.value)
                                                if(billing_party_raw){
                                                  setFieldValue(
                                                    `deliveries[${index}].billing_party_name`,
                                                    billing_party_raw.text
                                                  );
                                                }
                                                checkBillingParty(name, data, setFieldValue, `deliveries[${index}].customer_type_id`, `deliveries[${index}].customer_type_name`);
                                              }}
                                            />
                                            {touched.billing_party_id &&
                                              errors.billing_party_id ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `proposed_vehicle_type.error_msg.${errors.billing_party_id}`
                                                ) || errors.billing_party_id}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>

                                          <FormUi.Field width={1} />

                                          <FormUi.Field
                                            width={2}
                                          >
                                            <label
                                              className="labelName"
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {props.t(
                                                "delivery_form.billing_party_branch.title"
                                              ) ||
                                                "Billing Party Branch"}{" "}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Dropdown
                                              name={`deliveries[${index}].billing_party_branch_id`}
                                              placeholder={
                                                values.deliveries[index]
                                                  .billing_party_branch_name
                                                  ? values.deliveries[index]
                                                    .billing_party_branch_name
                                                  : props.t(
                                                    "delivery_form.billing_party_branch.placeholder"
                                                  ) ||
                                                  "Billing Party Branch"
                                              }
                                              clearable
                                              style={{ width: "100%" }}
                                              selection
                                              search
                                              onChange={(name, data) => {
                                                data.options.map(
                                                  (item, o) => {
                                                    if (
                                                      item.raw
                                                        .billingPartyBranchId ==
                                                      data.value
                                                    ) {
                                                      setFieldValue(
                                                        `deliveries[${index}].billing_party_branch_name`,
                                                        item.raw
                                                          .billingPartyBranchName
                                                      );
                                                    }
                                                  }
                                                );
                                                setFieldValue(
                                                  `deliveries[${index}].billing_party_branch_id`,
                                                  +data.value
                                                );
                                              }}
                                              options={billingpartybranch}
                                            />
                                          </FormUi.Field>

                                          <FormUi.Field width={6} />

                                        </FormUi.Group>
                                      </Table.Cell>

                                      {/* {localStorage.getItem("billingpartIds") !=
                                              "" ? ( */}

                                      {/* ) : null} */}
                                    </Table.Row>
                                  </>
                                ) : null}

                                <Table.Row>

                                  <Table.Cell colSpan="4">
                                    <FormUi.Group>
                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {props.t("booking_branch.title") ||
                                            "Booking Branch"}{" "}
                                          {deliverOrderDetailsAccess && <MandatoryMark />}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Dropdown
                                          name={`deliveries[${index}].booking_branch_name`}
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          loading={isloading}
                                          selection
                                          placeholder={
                                            values.deliveries[index].booking_branch_name
                                              ? values.deliveries[index].booking_branch_name :
                                              props.t(
                                                "booking_branch.placeholder"
                                              ) || "Booking Branch"

                                          }
                                          onChange={(name, data) => {
                                            data.options.map((item, o) => {
                                              if (item.raw.branchId == data.value) {
                                                // setFieldValue(
                                                //   "booking_branch_name",
                                                //   item.raw.branchName
                                                // );
                                                setFieldValue(
                                                  `deliveries[${index}].booking_branch_name`,
                                                  item.raw.branchName
                                                );
                                              }
                                            });
                                            // setFieldValue(
                                            //   "booking_branch_id",
                                            //   data.value
                                            // );
                                            setFieldValue(
                                              `deliveries[${index}].booking_branch_id`,
                                              +data.value
                                            );
                                            FEATURES.lr_series_activated && handleLRSeriesNo(data.value, index,setFieldValue)
                                          }}
                                          options={userbranchs}
                                        />
                                        {touched.deliveries && touched.deliveries[index] && touched.deliveries[index].booking_branch_name &&
                                         errors.deliveries && errors.deliveries[index] && errors.deliveries[index].booking_branch_name ? (
                                          <div className="w3-small w3-text-red">
                                            {errors.deliveries[index].booking_branch_name}
                                          </div>
                                        ) : null}
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />

                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {props.t("billing_branch.title") ||
                                            "Billing Branch"}{" "}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Dropdown
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          loading={isloading}
                                          selection
                                          placeholder={
                                            values.billing_branch_name
                                              ? values.billing_branch_name
                                              : props.t(
                                                "billing_branch.placeholder"
                                              ) || "Billing Branch"
                                          }
                                          onChange={(name, data) => {
                                            data.options.map((item, o) => {
                                              if (
                                                item.raw.branchId == data.value
                                              ) {
                                                setFieldValue(
                                                  "billing_branch_name",
                                                  item.raw.branchName
                                                );
                                                setFieldValue(
                                                  `deliveries[${index}].billing_branch_name`,
                                                  item.raw.branchName
                                                );
                                              }
                                            });
                                            setFieldValue(
                                              "billing_branch_id",
                                              data.value
                                            );
                                            setFieldValue(
                                              `deliveries[${index}].billing_branch_id`,
                                              +data.value
                                            );
                                          }}
                                          options={userbranchs}
                                        />
                                        {touched.service_type_id &&
                                          errors.service_type_id ? (
                                          <div className="w3-small w3-text-red">
                                            {props.t(
                                              `billing_branch.error_msg.${errors.billing_branch}`
                                            ) || errors.billing_branch}
                                          </div>
                                        ) : null}
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />

                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {props.t(
                                            "delivery_form.customer_type.title"
                                          ) || "Customer Type"}{" "}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Dropdown
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          selection
                                          name={`deliveries[${index}].customer_type_name`}
                                          placeholder={
                                            values?.deliveries?.[index]
                                              ?.customer_type_name ?
                                              values.deliveries[index]
                                                .customer_type_name :
                                              "Customer Type"
                                          }
                                          value={
                                            values.deliveries[index]
                                              .customer_type_id
                                          }
                                          onChange={(name, data) => {
                                            if (data?.value) {
                                              setFieldValue(
                                                `deliveries[${index}].customer_type_id`,
                                                data.value
                                              )
                                            }

                                          }
                                          }
                                          options={customertype}
                                        />
                                        {touched.customer_type_id &&
                                          errors.customer_type_id ? (
                                          <div className="w3-small w3-text-red">
                                            {props.t(
                                              `proposed_vehicle_type.error_msg.${errors.customer_type_id}`
                                            ) || errors.customer_type_id}
                                          </div>
                                        ) : null}
                                      </FormUi.Field>
                                    </FormUi.Group>
                                  </Table.Cell>


                                </Table.Row>

                                <Table.Row>
                                  <Table.Cell colSpan="4">

                                    {!FEATURES.createOrderHideBillingPartyComponent ? (
                                      <>
                                        <FormUi.Group>
                                          {!FEATURES.createOrderhideFields ? (
                                            <>
                                              <FormUi.Field
                                                width={2}
                                              >
                                                <label
                                                  className="labelName"
                                                  style={{ whiteSpace: "nowrap" }}
                                                >
                                                  {props.t(
                                                    "delivery_form.billing_party.title"
                                                  ) || "Billing Party"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <FormUi.Field width={3}>
                                                <Fieldmik
                                                  name={`deliveries[${index}].billing_party_id`}
                                                  defaultValue={
                                                    values.deliveries[index]
                                                      .billing_party_id
                                                  }
                                                  placeholder={
                                                    props.t(
                                                      "delivery_form.billing_party.placeholder"
                                                    ) || "Billing Party"
                                                  }
                                                  component={MyBillingPartyComponent}
                                                  onChange={(name, data) => {
                                                    setFieldValue(
                                                      `deliveries[${index}].billing_party_id`,
                                                      +data.value
                                                    );
                                                  let billing_party_raw = data?.options?.find((obj)=> obj.value == data.value)
                                                  if(billing_party_raw){
                                                    setFieldValue(
                                                      `deliveries[${index}].billing_party_name`,
                                                      billing_party_raw.text
                                                    );
                                                  }
                                                    // checkBillingParty(name, data);
                                                    checkBillingParty(name, data, setFieldValue, `deliveries[${index}].customer_type_id`, `deliveries[${index}].customer_type_name`);

                                                  }}
                                                />
                                                {touched.billing_party_id &&
                                                  errors.billing_party_id ? (
                                                  <div className="w3-small w3-text-red">
                                                    {props.t(
                                                      `proposed_vehicle_type.error_msg.${errors.billing_party_id}`
                                                    ) || errors.billing_party_id}
                                                  </div>
                                                ) : null}
                                              </FormUi.Field>

                                            </>
                                          ) : null}
                                          <FormUi.Field width={1} />
                                          {!FEATURES.createOrderhideFields ? (
                                            <>
                                              <FormUi.Field
                                                width={2}

                                              >
                                                <label
                                                  className="labelName"
                                                  style={{ whiteSpace: "nowrap" }}
                                                >
                                                  {props.t(
                                                    "delivery_form.billing_party_branch.title"
                                                  ) || "Billing Party Branch"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <FormUi.Field width={3}>
                                                <Dropdown
                                                  name={`deliveries[${index}].billing_party_branch_id`}
                                                  placeholder={
                                                    values.deliveries[index]
                                                      .billing_party_branch_name
                                                      ? values.deliveries[index]
                                                        .billing_party_branch_name
                                                      : props.t(
                                                        "delivery_form.billing_party_branch.placeholder"
                                                      ) || "Billing Party Branch"
                                                  }
                                                  clearable
                                                  style={{ width: "100%" }}
                                                  selection
                                                  search
                                                  onChange={(name, data) => {
                                                    data.options.map((item, o) => {
                                                      if (
                                                        item.raw
                                                          .billingPartyBranchId ==
                                                        data.value
                                                      ) {
                                                        setFieldValue(
                                                          `deliveries[${index}].billing_party_branch_name`,
                                                          item.raw
                                                            .billingPartyBranchName
                                                        );
                                                      }
                                                    });
                                                    setFieldValue(
                                                      `deliveries[${index}].billing_party_branch_id`,
                                                      +data.value
                                                    );
                                                  }}
                                                  options={billingpartybranch}
                                                />
                                              </FormUi.Field>

                                              <FormUi.Field width={1} />
                                              <FormUi.Field
                                                width={2}

                                              >
                                                <label
                                                  className="labelName"
                                                  style={{ whiteSpace: "nowrap" }}
                                                >
                                                  { FEATURES.customerLabelNames() && FEATURES.customerLabelNames().vendor_lr_no ? 
                                                  FEATURES.customerLabelNames().vendor_lr_no :
                                                    (props.t(
                                                      "delivery_form.transporter_lr_no.vendor_title"
                                                    ) || "Vendor LR No")
                                                  }
                                                </label>
                                              </FormUi.Field>

                                              <FormUi.Field width={3}>
                                                <Fieldmik
                                                  component={MyInput}
                                                  style={{
                                                    paddingTop: "5.5px",
                                                    whiteSpace: "nowrap",
                                                  }}

                                                  value={
                                                    values.deliveries[index]
                                                      .transporter_lr_no
                                                  }
                                                  name={`deliveries[${index}].transporter_lr_no`}
                                                />
                                              </FormUi.Field>
                                            </>
                                          ) : null}
                                        </FormUi.Group>
                                      </>
                                    ) : null}
                                  </Table.Cell>
                                </Table.Row>

                                {FEATURES.createOrderBillingPartyOnlyForPrimary && props.moment == "primary" ? (
                                  <>
                                    <Table.Row>
                                      <Table.Cell colSpan="1">
                                        <FormUi.Field
                                          width={3}
                                          className="m-0 mb-2"
                                        >
                                          <label
                                            className="labelName"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.billing_party.title"
                                            ) || "Billing Party"}{" "}
                                            <MandatoryMark />
                                          </label>
                                        </FormUi.Field>
                                        <Fieldmik
                                          name={`deliveries[${index}].billing_party_id`}
                                          defaultValue={
                                            values.deliveries[index]
                                              .billing_party_id
                                          }
                                          placeholder={
                                            props.t(
                                              "delivery_form.billing_party.placeholder"
                                            ) || "Billing Party"
                                          }
                                          component={BillingPartyDropdown}
                                          billingPartyBranchName={`deliveries[${index}].billing_party_branch_id`}
                                          consignorCode={`deliveries[${index}].consignor_code`}
                                          consignorGst={`deliveries[${index}].consignor_gstNumber`}
                                          consignorAddress={`deliveries[${index}].consignor_address`}
                                          consignorName={`deliveries[${index}].consignor_name`}
                                          consigneeCode={`deliveries[${index}].consignee_code`}
                                          consigneeGst={`deliveries[${index}].consignee_gstNumber`}
                                          consigneeAddress={`deliveries[${index}].consignee_address`}
                                          consigneeName={`deliveries[${index}].consignee_name`}
                                          orderModal={true}
                                          getBillingPartySelected={
                                            getBillingPartySelected
                                          }
                                        />
                                        {
                                          <ErrorMessage
                                            name={`deliveries[${index}].billing_party_id`}
                                          >
                                            {(error) => <div>{error}</div>}
                                          </ErrorMessage>
                                        }
                                      </Table.Cell>

                                      <Table.Cell colSpan="1">
                                        <FormUi.Field
                                          width={3}
                                          className="m-0 mb-2"
                                        >
                                          <label
                                            className="labelName"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.billing_party_branch.title"
                                            ) || "Billing Party Branch"}{" "}
                                            <MandatoryMark />
                                          </label>
                                        </FormUi.Field>
                                        <Fieldmik
                                          name={`deliveries[${index}].billing_party_branch_id`}
                                          component={BillingPartyBranchDropdown}
                                          setBillingBranchName={(
                                            branchName,
                                            branchId
                                          ) => {
                                            // setFieldValue(`deliveries[${index}].billing_party_branch_name`, branchName);
                                            getConsigneeConsignorArray(
                                              values.deliveries[index]
                                                .billing_party_id,
                                              branchId
                                            );
                                          }}
                                          value={
                                            values.deliveries[index]
                                              .billing_party_branch_id
                                          }
                                          billingPartyBranchArray={
                                            billingpartybranch
                                          }
                                        />
                                        {
                                          <ErrorMessage
                                            name={`deliveries[${index}].billing_party_branch_id`}
                                          >
                                            {(error) => <div>{error}</div>}
                                          </ErrorMessage>
                                        }
                                      </Table.Cell>

                                      {values.deliveries[index].deliver_to ==
                                        "branch" ? (
                                        <>
                                          <Table.Cell colSpan="1">
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.deliver_to_branch.title"
                                                ) || "Deliver To"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <Dropdown
                                              name={`deliveries[${index}].deliver_to_address`}
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.deliver_to_branch.placeholder"
                                                ) || "Deliver To"
                                              }
                                              onChange={(name, data) => {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  data.value
                                                );
                                              }}
                                              options={branchs}
                                              value={
                                                values.deliveries[index]
                                                  .deliver_to_address
                                              }
                                            />
                                          </Table.Cell>
                                        </>
                                      ) : null}
                                      {values.deliveries[index].deliver_to ==
                                        "other" ? (
                                        <>
                                          <Table.Cell colSpan="1">
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.reason.title"
                                                ) || "Reason"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              error={
                                                touched.other && errors.other
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Fieldmik
                                                component="textarea"
                                                style={{
                                                  paddingTop: "5.5px",
                                                  whiteSpace: "nowrap",
                                                }}
                                                type="number"
                                                rows="2"
                                                name={`deliveries[${index}].deliver_to_address`}
                                              />
                                            </FormUi.Field>
                                          </Table.Cell>
                                        </>
                                      ) : null}
                                    </Table.Row>
                                  </>
                                ) : (
                                  ""
                                )}

                                <Table.Row key={index}>
                                  <Table.Cell colSpan="4">
                                    <FormUi.Group>
                                      {props.moment != "primary" &&
                                        props.moment == "export" ? (
                                        <>
                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.yard.title"
                                              ) || "Yard"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.container_type &&
                                                errors.container_type
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              search
                                              name={`deliveries[${index}].yard_id`}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.yard.title"
                                                ) || "Yard"
                                              }
                                              defaultValue={
                                                values.deliveries[index].yard_id
                                              }
                                              onChange={(name, data) =>
                                                setFieldValue(
                                                  `deliveries[${index}].yard_id`,
                                                  data.value
                                                )
                                              }
                                              options={yard}
                                            />
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />
                                        </>
                                      ) : null}

                                      <FormUi.Field width={2}>
                                        <label className="labelName">
                                          {props.moment == "import" ? (
                                            <>
                                              {props.t(
                                                "delivery_form.port_terminal.title"
                                              ) || "Port Terminal"}{" "}
                                              <MandatoryMark />
                                            </>
                                          ) : (
                                            <>
                                              {props.moment == "export" ? (
                                                <>
                                                  {props.t(
                                                    "delivery_form.export_pickup_location.title"
                                                  ) || "Stuffing location"}{" "}
                                                  <MandatoryMark />
                                                </>
                                              ) : (
                                                <>
                                                  {props.t(
                                                    "delivery_form.consignor.title"
                                                  ) || "Consignor"}{" "}
                                                  <MandatoryMark />
                                                </>
                                              )}
                                            </>
                                          )}
                                        </label>
                                      </FormUi.Field>

                                      <FormUi.Field width={3}>
                                        <div className="d-flex flex-row action input">
                                          <Fieldmik
                                            name={`deliveries[${index}].consignor_code`}
                                            placeholder={
                                              props.moment == "import"
                                                ? values.deliveries[index]
                                                  .consignor_name
                                                  ? values.deliveries[index]
                                                    .consignor_name
                                                  : props.t(
                                                    "delivery_form.port_terminal.placeholder"
                                                  ) || "Delivery Location"
                                                : values.deliveries[index]
                                                  .consignor_name
                                                  ? values.deliveries[index]
                                                    .consignor_name
                                                  : props.moment == "export"
                                                    ? props.t(
                                                      "delivery_form.pickup_location.placeholder"
                                                    )
                                                    : props.t(
                                                      "delivery_form.consignor.placeholder"
                                                    )
                                            }
                                            consignorIDName={`deliveries[${index}].consignor_id`}
                                            component={MyConsignor}
                                            mode={props.mode}
                                            value={
                                              values.deliveries[index]
                                                .consignor_code
                                            }
                                            setConsignorArray={setConsignorArray}
                                            consignorArray={consignorArray}
                                            gst={`deliveries[${index}].consignor_gstNumber`}
                                            address={`deliveries[${index}].consignor_address`}
                                            cname={`deliveries[${index}].consignor_name`}
                                          />
                                          <ModalCreateConsignor
                                            reFetchConsignor={getIntialCall}
                                          />
                                        </div>

                                        {
                                          <ErrorMessages
                                            name={`deliveries[${index}].consignor_code`}
                                            trans={"delivery_form.consignor"}
                                          />
                                        }<br /><br />
                                        <label className="labelName">Pickup Area</label>
                                        <Fieldmik
                                          name={`deliveries[${index}].pickup_area`}
                                          placeholder="Pickup Area"
                                          component={MyTextArea}
                                          value={
                                            values.deliveries[index]
                                              .pickup_area
                                          }
                                        />
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />

                                      <FormUi.Field width={2} >
                                        <label className="labelName">
                                          {props.moment == "import" ? (
                                            <>
                                              {props.t(
                                                "delivery_form.delivery_location.title"
                                              ) || "Delivery Location"}{" "}
                                              <MandatoryMark />
                                            </>
                                          ) : (
                                            <>
                                              {props.moment == "export" ? (
                                                <>
                                                  {props.t(
                                                    "delivery_form.port_terminal.title"
                                                  ) || "Port Terminal"}{" "}
                                                  <MandatoryMark />
                                                </>
                                              ) : (
                                                <>
                                                  {props.t(
                                                    "delivery_form.consignee.title"
                                                  ) || "Consignee"}{" "}
                                                  <MandatoryMark />
                                                </>
                                              )}
                                            </>
                                          )}
                                        </label>
                                      </FormUi.Field>

                                      <FormUi.Field width={3}>
                                        <div className="d-flex flex-row action input">
                                          <Fieldmik
                                            name={`deliveries[${index}].consignee_code`}
                                            placeholder={
                                              props.moment == "import"
                                                ? values.deliveries[index]
                                                  .consignee_name
                                                  ? values.deliveries[index]
                                                    .consignee_name
                                                  : props.t(
                                                    "delivery_form.delivery_location.placeholder"
                                                  ) || "Delivery Location"
                                                : values.deliveries[index]
                                                  .consignee_name
                                                  ? values.deliveries[index]
                                                    .consignee_name
                                                  : props.moment == "export"
                                                    ? props.t(
                                                      "delivery_form.port_terminal.placeholder"
                                                    )
                                                    : props.t(
                                                      "delivery_form.consignee.placeholder"
                                                    )
                                            }
                                            component={MyConsigneeComponent}
                                            consigneeIDName={`deliveries[${index}].consignee_id`}
                                            mode={props.mode}
                                            setConsigneeArray={setConsigneeArray}
                                            consigneeArray={consigneeArray}
                                            gst={`deliveries[${index}].consignee_gstNumber`}
                                            address={`deliveries[${index}].consignee_address`}
                                            deliverTo={`deliveries[${index}].deliver_to_address`}
                                            cename={`deliveries[${index}].consignee_name`}
                                            value={
                                              values.deliveries[index]
                                                .consignee_code
                                            }
                                          />

                                          <ModalCreateConsignee
                                            reFetchConsignee={() => getIntialCall()}
                                          />
                                        </div>
                                        {
                                          <ErrorMessages
                                            name={`deliveries[${index}].consignee_code`}
                                            trans={"delivery_form.consignee"}
                                          />
                                        }<br /><br />
                                        <label className="labelName">Drop Area</label>
                                        <Fieldmik
                                          name={`deliveries[${index}].drop_area`}
                                          placeholder="Drop Area"
                                          component={MyTextArea}
                                          value={
                                            values.deliveries[index]
                                              .drop_area
                                          }
                                        />
                                      </FormUi.Field>


                                      {props.moment != "primary" &&
                                        props.moment == "import" ? (
                                        <>
                                          <FormUi.Field width={1} />
                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.yard.title"
                                              ) || "Yard"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.container_type &&
                                                errors.container_type
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              search
                                              name={`deliveries[${index}].yard_id`}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.yard.title"
                                                ) || "Yard"
                                              }
                                              defaultValue={
                                                values.deliveries[index].yard_id
                                              }
                                              onChange={(name, data) =>
                                                setFieldValue(
                                                  `deliveries[${index}].yard_id`,
                                                  data.value
                                                )
                                              }
                                              options={yard}
                                            />
                                          </FormUi.Field>

                                        </>
                                      ) : null}


                                      {FEATURES.createOrderDeliverTo || props.moment == "export" ||
                                        props.moment == "import" ? null : (
                                        <>
                                          <FormUi.Field width={1} />
                                          <FormUi.Field width={2}>
                                            <label
                                              className="m-0 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.deliver_to.title"
                                              ) || "Deliver To"}{" "}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.deliver_to &&
                                                errors.deliver_to
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              name={`deliveries[${index}].deliver_to`}
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.deliver_to.placeholder"
                                                ) || "Deliver To"
                                              }
                                              onChange={(name, data) => {
                                                if (data.value == "consignee") {
                                                  setFieldValue(
                                                    `deliveries[${index}].deliver_to_address`,
                                                    values.deliveries[index]
                                                      .consignee_address
                                                  );
                                                } else if (data.value == "other") {
                                                  setFieldValue(
                                                    `deliveries[${index}].deliver_to_address`,
                                                    ""
                                                  );
                                                }
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to`,
                                                  data.value
                                                );
                                              }}
                                              options={[
                                                {
                                                  key: "1",
                                                  text: "Consignee",
                                                  value: "consignee",
                                                },
                                                {
                                                  key: "2",
                                                  text: "Branch",
                                                  value: "branch",
                                                },
                                                {
                                                  key: "3",
                                                  text: "Other",
                                                  value: "other",
                                                },
                                              ]}
                                              value={
                                                values.deliveries[index].deliver_to
                                                  ? values.deliveries[index]
                                                    .deliver_to
                                                  : "consignee"
                                              }
                                            />
                                            {touched.deliver_to &&
                                              errors.deliver_to ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `shipment_form.deliver_to.error_msg.${errors.deliver_to}`
                                                ) || errors.deliver_to}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                        </>
                                      )}

                                      {FEATURES.createOrderDeliverTo ? (
                                        <>
                                          <FormUi.Field width={1} />
                                          <FormUi.Field width={2}>
                                            <label
                                              className="m-0 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.deliver_to.title"
                                              ) || "Deliver To"}{" "}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.deliver_to &&
                                                errors.deliver_to
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              name={`deliveries[${index}].deliver_to`}
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.deliver_to.placeholder"
                                                ) || "Deliver To"
                                              }
                                              onChange={(name, data) => {
                                                if (data.value == "consignee") {
                                                  setFieldValue(
                                                    `deliveries[${index}].deliver_to_address`,
                                                    values.deliveries[index]
                                                      .consignee_address
                                                  );
                                                } else if (
                                                  data.value == "other"
                                                ) {
                                                  setFieldValue(
                                                    `deliveries[${index}].deliver_to_address`,
                                                    ""
                                                  );
                                                }
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to`,
                                                  data.value
                                                );
                                              }}
                                              options={[
                                                {
                                                  key: "1",
                                                  text: "Consignee",
                                                  value: "consignee",
                                                },
                                                {
                                                  key: "2",
                                                  text: "Branch",
                                                  value: "branch",
                                                },
                                                {
                                                  key: "3",
                                                  text: "Other",
                                                  value: "other",
                                                },
                                              ]}
                                              value={
                                                values.deliveries[index]
                                                  .deliver_to
                                                  ? values.deliveries[index]
                                                    .deliver_to
                                                  : "consignee"
                                              }
                                            />
                                            {touched.deliver_to &&
                                              errors.deliver_to ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `shipment_form.deliver_to.error_msg.${errors.deliver_to}`
                                                ) || errors.deliver_to}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                        </>
                                      ) : null}
                                    </FormUi.Group>
                                  </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                  <Table.Cell colSpan="4">
                                    <FormUi.Group>
                                      {props.moment !== "export" &&
                                        <>
                                          <FormUi.Field width={2} />
                                          <FormUi.Field width={3}>

                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.port_terminal_address.title"
                                                    ) || "Port Terminal Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignor_address.title"
                                                    ) || "Consignor Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignor_address
                                                  ? values.deliveries[index]
                                                    .consignor_address
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component="textarea"
                                        rows="2"
                                        name={`deliveries[${index}].consignor_address`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignor_address
                                        }
                                      /> */}
                                            </div>

                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignor_gst.title"
                                                    ) || "Port Terminal Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignor_gst.title"
                                                    ) || "Consignor Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignor_gstNumber
                                                  ? values.deliveries[index]
                                                    .consignor_gstNumber
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component={MyNormalInput}
                                        rows="2"
                                        name={`deliveries[${index}].consignor_gstNumber`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignor_gstNumber
                                        }
                                      /> */}
                                            </div>
                                          </FormUi.Field>

                                          <FormUi.Field width={3} />
                                          <FormUi.Field width={3}>
                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.delivery_location_address.title"
                                                    ) ||
                                                      "Delivery Location Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_address.title"
                                                    ) || "Consignee Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignee_address
                                                  ? values.deliveries[index]
                                                    .consignee_address
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component="textarea"
                                        rows="2"
                                        name={`deliveries[${index}].consignee_address`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignee_address
                                        }
                                      /> */}
                                            </div>
                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_gst.title"
                                                    ) ||
                                                      "Delivery Location Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_gst.title"
                                                    ) || "Consignee Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignee_gstNumber
                                                  ? values.deliveries[index]
                                                    .consignee_gstNumber
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component={MyNormalInput}
                                        rows="2"
                                        name={`deliveries[${index}].consignee_gstNumber`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignee_gstNumber
                                        }
                                      /> */}
                                            </div>
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />
                                        </>
                                      }

                                      <>
                                        {values.deliveries[index].deliver_to ==
                                          "consignee" ? (
                                          <>
                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.delivery_location_address.title"
                                                    ) ||
                                                      "Delivery Location Address"}{" "}
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_address.title"
                                                    ) || "Consignee Address"}{" "}
                                                  </>
                                                )}
                                              </label>
                                            </FormUi.Field>

                                            <FormUi.Field width={3}>
                                              <Fieldmik
                                                readOnly
                                                component="textarea"
                                                rows="2"
                                                name={`deliveries[${index}].deliver_to_address`}
                                                value={
                                                  values.deliveries[index]
                                                    .deliver_to_address
                                                }
                                              />
                                            </FormUi.Field>
                                          </>
                                        ) : null}

                                        {values.deliveries[index].deliver_to ==
                                          "branch" ? (
                                          <>

                                            <FormUi.Field width={2}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.deliver_to_branch.title"
                                                ) || "Deliver To"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <Dropdown
                                                name={`deliveries[${index}].deliver_to_address`}
                                                clearable
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.deliver_to_branch.placeholder"
                                                  ) || "Deliver To"
                                                }
                                                onChange={(name, data) => {
                                                  setFieldValue(
                                                    `deliveries[${index}].deliver_to_address`,
                                                    data.value
                                                  );
                                                }}
                                                options={branchs}
                                                value={
                                                  values.deliveries[index]
                                                    .deliver_to_address
                                                }
                                              />
                                            </FormUi.Field>
                                          </>
                                        ) : null}

                                        {values.deliveries[index].deliver_to ==
                                          "other" ? (
                                          <>

                                            <FormUi.Field width={2}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.reason.title"
                                                ) || "Reason"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              width={3}
                                              error={
                                                touched.other && errors.other
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Fieldmik
                                                component="textarea"
                                                style={{
                                                  paddingTop: "5.5px",
                                                  whiteSpace: "nowrap",
                                                }}
                                                type="number"
                                                rows="2"
                                                name={`deliveries[${index}].deliver_to_address`}
                                              />
                                            </FormUi.Field>

                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                      {props.moment === "export" &&
                                        <>
                                          <FormUi.Field width={3} />
                                          <FormUi.Field width={3}>

                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.port_terminal_address.title"
                                                    ) || "Port Terminal Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignor_address.title"
                                                    ) || "Consignor Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignor_address
                                                  ? values.deliveries[index]
                                                    .consignor_address
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component="textarea"
                                        rows="2"
                                        name={`deliveries[${index}].consignor_address`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignor_address
                                        }
                                      /> */}
                                            </div>

                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignor_gst.title"
                                                    ) || "Port Terminal Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignor_gst.title"
                                                    ) || "Consignor Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignor_gstNumber
                                                  ? values.deliveries[index]
                                                    .consignor_gstNumber
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component={MyNormalInput}
                                        rows="2"
                                        name={`deliveries[${index}].consignor_gstNumber`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignor_gstNumber
                                        }
                                      /> */}
                                            </div>
                                          </FormUi.Field>

                                          <FormUi.Field width={3} />
                                          <FormUi.Field width={3}>
                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.delivery_location_address.title"
                                                    ) ||
                                                      "Delivery Location Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_address.title"
                                                    ) || "Consignee Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignee_address
                                                  ? values.deliveries[index]
                                                    .consignee_address
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component="textarea"
                                        rows="2"
                                        name={`deliveries[${index}].consignee_address`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignee_address
                                        }
                                      /> */}
                                            </div>
                                            <div>
                                              <label className="labelName">
                                                {props.moment == "import" ||
                                                  props.moment == "export" ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_gst.title"
                                                    ) ||
                                                      "Delivery Location Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.consignee_gst.title"
                                                    ) || "Consignee Address"}{" "}
                                                    <span> : </span>
                                                  </>
                                                )}
                                              </label>
                                              <label className="labelName address-label-shipment">
                                                &nbsp;
                                                {values.deliveries[index]
                                                  .consignee_gstNumber
                                                  ? values.deliveries[index]
                                                    .consignee_gstNumber
                                                  : "NA"}
                                              </label>
                                              {/* <Fieldmik
                                        readOnly
                                        component={MyNormalInput}
                                        rows="2"
                                        name={`deliveries[${index}].consignee_gstNumber`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignee_gstNumber
                                        }
                                      /> */}
                                            </div>
                                          </FormUi.Field>

                                        </>
                                      }

                                    </FormUi.Group>
                                  </Table.Cell>
                                </Table.Row>

                                {!FEATURES.createOrderhideFields ? (
                                  <>

                                    <Table.Row>
                                      <Table.Cell colSpan="4">
                                        <FormUi.Group>
                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.total_quantity.title"
                                              ) || "Total Ordered Quantity (No.of boxes)"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3} error={errors.total_quantity ? true : false}>
                                            <Fieldmik
                                              component={MyNumInput}
                                              type="number"
                                              value={values?.deliveries?.[index]?.total_quantity}
                                              name={`deliveries[${index}].total_quantity`}
                                              onChange={(name, data) => {
                                                setFieldValue(
                                                  `deliveries[${index}].total_quantity`, data.value
                                                );

                                                let multiplyFactor = 0, actualValue = 0;
                                                let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;
                                                if (values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name) {
                                                  if (values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CASE") {
                                                    multiplyFactor = data.value;
                                                    actualValue = multiplyFactor * actualFreightValue;
                                                    setFieldValue(
                                                      `deliveries[${index}].final_freight_rate`, actualValue
                                                    );
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                                  }
                                                }
                                              }}
                                              onBlur={() => {
                                                if (!alloted_orders_quantity && values?.deliveries?.[index]?.total_quantity != getCounts(values.deliveries[index].products) && getCounts(values.deliveries[index].products) != 0) {
                                                  setQuantityModal(true)
                                                  setQuantityIndex(index)
                                                }
                                              }}
                                            />
                                            {/* <div style={{ color: 'red' }}>
                                            {
                                              getCounts(values.deliveries[index].products) != 0 && getCounts(values.deliveries[index].products) != values.deliveries[index]
                                                .total_quantity ?
                                                errors.total_quantity = 'Total Quantity is not matched to product quantity'
                                                : delete errors.total_quantity
                                            }
                                          </div> */}
                                          </FormUi.Field>

                                          <FormUi.Field width={1} />

                                          <FormUi.Field
                                            width={2}
                                            className="m-0 mb-2"
                                            error={
                                              touched.service_type_id && errors.service_type_id
                                                ? true
                                                : false
                                            }
                                          >
                                            <label className="labelName"
                                              style={{ whiteSpace: "nowrap" }}>
                                              {props.t("service_type.title") || "Service Types"}{" "}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}>
                                            <Dropdown
                                              name={`deliveries[${index}].service_type_id`}
                                              clearable
                                              style={{ width: "100%", fontWeight: "normal" }}
                                              search
                                              loading={isloading}
                                              selection
                                              placeholder={
                                                props.t("service_type.placeholder") ||
                                                "Service Type"
                                              }
                                              defaultValue={values.deliveries.service_type_id}
                                              onChange={(name, data) =>
                                                setFieldValue(`deliveries[${index}].service_type_id`, data.value)
                                              }
                                              options={service}
                                            />
                                            {touched.service_type_id &&
                                              errors.service_type_id ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `service_type.error_msg.${errors.service_type}`
                                                ) || errors.service_type}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />

                                          <FormUi.Field
                                            width={2}
                                            className="m-0 mb-2"
                                            error={
                                              touched.service_type_id && errors.service_type_id
                                                ? true
                                                : false
                                            }
                                          >
                                            <label className="labelName"
                                              style={{ whiteSpace: "nowrap" }}>
                                              {FEATURES.brokerInsteadOfSalesPerson ? (props.t("broker.title") || "Broker") : (props.t("sales_person.title") || "Sales Person")}{" "}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}>
                                            <Fieldmik
                                              placeholder= {FEATURES.brokerInsteadOfSalesPerson ? (props.t("broker.placeholder") || "Broker") : (props.t("sales_person.placeholder") || "Select Sales Person")}
                                              component={MyUser}
                                              name={`deliveries[${index}].sales_person_id`}
                                              roleValidation={true}
                                              roleName={FEATURES.brokerInsteadOfSalesPerson ? "broker" : "sales"}
                                              userNumber={`deliveries[${index}].sales_person_number`}
                                              userEmail={`deliveries[${index}].sales_person_email`}
                                            />
                                            {values.deliveries[index].sales_person_id && 
                                              <div className="mt-1">
                                              <div>
                                                <span className="address-label">{"Contact Number"}</span>
                                                <span className="address-inputfields"> : {values.deliveries[index].sales_person_number}
                                                </span>
                                              </div>
                                              <div>
                                                <span className="address-label">{"Email Id"}</span>
                                                <span className="address-inputfields"> : {values.deliveries[index].sales_person_email}
                                                </span>
                                              </div>
                                            </div>
                                              }
                                            {touched.sales_person_id &&
                                              errors.sales_person_id ? (
                                              <div className="w3-small w3-text-red">
                                                {errors.sales_person_id}
                                              </div>
                                            ) : null}
                                            
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Table.Cell>
                                    </Table.Row>

                                    <Table.Row>
                                      <Table.Cell colSpan="4">
                                        <FormUi.Group>
                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {(FEATURES.weightInTonCustomers ? props.t("delivery_form.actual_weight.title_ton") : props.t("delivery_form.actual_weight.title"))
                                                || "Actual Weight"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Input
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                              type={FEATURES.weightInTonCustomers ? "text" : "number"}
                                              value={
                                                values.deliveries[index]
                                                  .actual_weight
                                              }
                                              name={`deliveries[${index}].actual_weight`}
                                              onBlur={() => {
                                                setFieldValue(`deliveries[${index}].grossWeightFlag`, false),
                                                setFieldValue(`deliveries[${index}].chargedWeightFlag`, false)
                                              }}
                                              onChange={(name, data) => {
                                                if(FEATURES.weightInTonCustomers){
                                                  setFieldValue(`deliveries[${index}].actual_weight`, data.value);
                                                  if (data.value && values.deliveries[index].grossWeightFlag && values.deliveries[index].chargedWeightFlag) {
                                                    setFieldValue(`deliveries[${index}].gross_weight`, data.value)
                                                    setFieldValue(`deliveries[${index}].charged_weight`, data.value);
                                                  }
                                                }else{
                                                if (data.value != "") {
                                                  setFieldValue(`deliveries[${index}].actual_weight`, parseInt(data.value))
                                                  if (data.value && values.deliveries[index].grossWeightFlag && values.deliveries[index].chargedWeightFlag) {
                                                    setFieldValue(`deliveries[${index}].gross_weight`, parseInt(data.value))
                                                    setFieldValue(`deliveries[${index}].charged_weight`, parseInt(data.value));
                                                  }
                                                } else {
                                                  setFieldValue(`deliveries[${index}].actual_weight`, null)
                                                  if (data.value && values.deliveries[index].grossWeightFlag && values.deliveries[index].chargedWeightFlag) {
                                                    setFieldValue(`deliveries[${index}].gross_weight`, null)
                                                    setFieldValue(`deliveries[${index}].charged_weight`, null);
                                                  }
                                                }
                                              } 
                                              }
                                              }
                                            />
                                            <ErrorMessages
                                            name={`deliveries[${index}].actual_weight`}
                                            trans={"delivery_form.actual_weight"}
                                          />
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />

                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {(FEATURES.weightInTonCustomers? props.t("delivery_form.gross_weight.title_ton") : props.t("delivery_form.gross_weight.title")) 
                                              || "Gross Weight"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Input
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                              type={FEATURES.weightInTonCustomers ? "text" : "number"}
                                              value={
                                                values.deliveries[index]
                                                  .gross_weight
                                              }
                                              name={`deliveries[${index}].gross_weight`}
                                              onBlur={() => setFieldValue(`deliveries[${index}].chargedWeightFlag`, false)}
                                              onChange={(name, data) => {
                                                if(FEATURES.weightInTonCustomers){
                                                  setFieldValue(`deliveries[${index}].gross_weight`, data.value)
                                                  if (data.value && values?.deliveries[index]?.chargedWeightFlag) {
                                                    setFieldValue(`deliveries[${index}].charged_weight`, data.value)
                                                  }
                                                }else{
                                                  if (data.value != "") {
                                                    setFieldValue(`deliveries[${index}].gross_weight`, parseInt(data.value))
                                                    if (data.value && values.deliveries[index].chargedWeightFlag) {
                                                      setFieldValue(`deliveries[${index}].charged_weight`, parseInt(data.value))
                                                    }
                                                  } else {
                                                    setFieldValue(`deliveries[${index}].gross_weight`, null)
                                                    if (data.value && values.deliveries[index].chargedWeightFlag) {
                                                      setFieldValue(`deliveries[${index}].charged_weight`, null)
                                                    }
                                                  }
                                                }
                                              }
                                              }
                                            />
                                            <ErrorMessages
                                            name={`deliveries[${index}].gross_weight`}
                                            trans={"delivery_form.gross_weight"}
                                          />
                                          </FormUi.Field>

                                          <FormUi.Field width={1} />

                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {(FEATURES.weightInTonCustomers?  props.t("delivery_form.charge_weight.title_ton") : props.t("delivery_form.charge_weight.title") )
                                              || "Charged Weight"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Input
                                              type={FEATURES.weightInTonCustomers ? "text" : "number"}
                                              value={
                                                values.deliveries[index]
                                                  .charged_weight
                                              }
                                              disabled={values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG" ? true : false}
                                              name={`deliveries[${index}].charged_weight`}
                                              onChange={(name, data) => {
                                                if(FEATURES.weightInTonCustomers){
                                                  setFieldValue(`deliveries[${index}].charged_weight`, data.value);
                                                }else{
                                                  if (data.value != "") {
                                                    setFieldValue(`deliveries[${index}].charged_weight`, parseInt(data.value));
                                                  } else {
                                                    setFieldValue(`deliveries[${index}].charged_weight`, null);
                                                  }
                                                }
                                                let multiplyFactor = 0, actualValue = 0;
                                                let actualFreightValue = values.deliveries[index].actual_freight_rate;

                                                if (
                                                  values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name
                                                ) {
                                                  multiplyFactor = data.value;
                                                  actualValue = multiplyFactor * data.value;
                                                  if (values?.deliveries?.[index]?.uom_name.toUpperCase() === "KG") {
                                                    multiplyFactor = FEATURES.weightInTonCustomers ? (Number(data.value) * 1000): data.value;
                                                    actualValue = multiplyFactor * actualFreightValue;
                                                    setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                                  } else if (values?.deliveries?.[index]?.uom_name.toUpperCase() === "TON") {
                                                    multiplyFactor = FEATURES.weightInTonCustomers ? data.value : (Number(data.value) / 1000);
                                                    actualValue = multiplyFactor * actualFreightValue;
                                                    setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                                  } else if (values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER TON PER KM") {
                                                    multiplyFactor = FEATURES.weightInTonCustomers ? data.value : (Number(data.value) / 1000);
                                                    let distance = props.bdistance;
                                                    actualValue = multiplyFactor * actualFreightValue * distance;
                                                    setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                                  }
                                                }
                                              }}
                                            />
                                            {
                                          <ErrorMessages
                                            name={`deliveries[${index}].charged_weight`}
                                            trans={"delivery_form.charged_weight"}
                                          />
                                          }
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Table.Cell>
                                    </Table.Row>
                                  </>
                                ) : null}


                                <Table.Row>
                                  <Table.Cell colSpan="4">
                                    <FormUi.Group>
                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"

                                        >
                                          {FEATURES.createOrderShowContainerPickupDate &&
                                            (props.values.values.movement_type ===
                                              "import" ||
                                              props.values.values.movement_type ===
                                              "export") ? (
                                            <>
                                              {props.t(
                                                "scheduled_requested_stuffing"
                                              ) ||
                                                "Schedule requested stuffing Date & Time"}
                                            </>
                                          ) : (
                                            <>
                                              {props.t(
                                                "delivery_form.container_pickup_date.title"
                                              ) || "Container Pickup Date"}{" "}
                                            </>
                                          )}
                                          <MandatoryMark />
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}>
                                        <DateData
                                          name={`deliveries[${index}].container_pickup_date_t`}
                                          tname={`deliveries[${index}].container_pickup_date`}
                                          autoComplete="off"
                                          showTimeSelect
                                          timeFormat="HH:mm"
                                          popperClassName="dateTime"
                                          dateFormat="dd/MM/yyyy HH:mm"
                                          timeIntervals={5}
                                          customInput={
                                            <Input
                                              icon="time"
                                              iconPosition="left"
                                            />
                                          }
                                        />
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />
                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"

                                        >
                                          {props.t(
                                            "delivery_form.container_return_date.title"
                                          ) || "Container Return Date"}{" "}
                                          <MandatoryMark />
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}>
                                        <DateData
                                          name={`deliveries[${index}].delivery_date_t`}
                                          tname={`deliveries[${index}].delivery_date`}
                                          autoComplete="off"
                                          showTimeSelect
                                          timeFormat="HH:mm"
                                          popperClassName="dateTime"
                                          dateFormat="dd/MM/yyyy HH:mm"
                                          timeIntervals={5}
                                          customInput={
                                            <Input
                                              icon="time"
                                              iconPosition="left"
                                            />
                                          }
                                        />
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />
                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"

                                        >
                                          {props.t(
                                            "delivery_form.insurance_no.title"
                                          ) || "Insurance Number"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}>
                                        <Fieldmik
                                              component={MyInput}
                                              name={`deliveries[${index}].insurance_no`}
                                            />
                                            {touched.insurance_no &&
                                              errors.insurance_no ? (
                                              <div className="w3-small w3-text-red">
                                                {errors.insurance_no}
                                              </div>
                                            ) : null}
                                      </FormUi.Field>
                                    </FormUi.Group>
                                  </Table.Cell>
                                </Table.Row>

                                { FEATURES.contractualCustomerFieldEnabled &&
                                  <Table.Row>
                                  <Table.Cell colSpan="4">
                                    <FormUi.Group>
                                      <FormUi.Field
                                        width={2}

                                      >
                                        <label
                                          className="labelName"

                                        >
                                          {props.t(
                                            "delivery_form.contractual_customer.title"
                                          ) || "Contractual Customer"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}>
                                        <Fieldmik
                                              component={MyBillingPartyComponent}
                                              name={`deliveries[${index}].contractual_customer_id`}
                                              placeholder = {"Contractual Customer"}
                                            />
                                            {
                                              <ErrorMessages
                                                name={`deliveries[${index}].contractual_customer_id`}
                                                trans={"delivery_form.contractual_customer_id"}
                                              />
                                            }
                                      </FormUi.Field>

                                      <FormUi.Field width={12} />
                                    </FormUi.Group>
                                  </Table.Cell>
                                </Table.Row>}


                                {(props.moment == "export" ||
                                  props.moment == "import") && (
                                    <>
                                      <Table.Row>
                                        <Table.Cell colSpan="4">
                                          <FormUi.Group>
                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.t(
                                                  "delivery_form.container_number.title"
                                                ) || "Container Number"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <Fieldmik
                                                component={MyInput}
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.container_number.title"
                                                  ) || "Container Type"
                                                }
                                                name={`deliveries[${index}].container_no`}
                                              />
                                            </FormUi.Field>
                                            <FormUi.Field width={1} />
                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.t(
                                                  "delivery_form.container_size.title"
                                                ) || "Container Size"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>

                                            <FormUi.Field
                                              width={3}
                                              error={
                                                touched.container_size &&
                                                  errors.container_size
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Dropdown
                                                clearable
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                search
                                                name={`deliveries[${index}].container_size`}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.container_size.title"
                                                  ) || "Container Type"
                                                }
                                                defaultValue={
                                                  values.deliveries[index]
                                                    .container_type
                                                }
                                                onChange={(name, data) =>
                                                  setFieldValue(
                                                    `deliveries[${index}].container_size`,
                                                    data.value
                                                  )
                                                }
                                                options={containerSizeList}
                                              />
                                              {touched.container_size &&
                                                errors.container_size ? (
                                                <div className="w3-small w3-text-red">
                                                  {props.t(
                                                    `container_type.error_msg.${errors.container_size}`
                                                  ) || errors.container_type}
                                                </div>
                                              ) : null}
                                            </FormUi.Field>
                                            <FormUi.Field width={1} />

                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.t(
                                                  "delivery_form.container_type_id.title"
                                                ) || "Container Type"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              width={3}
                                              error={
                                                touched.container_type &&
                                                  errors.container_type
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Dropdown
                                                clearable
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                search
                                                name={`deliveries[${index}].container_type_id`}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.container_type_id.title"
                                                  ) || "Container Type"
                                                }
                                                defaultValue={
                                                  values.deliveries[index]
                                                    .container_type_id
                                                }
                                                onChange={(name, data) => {
                                                  const selectedObj = data.options.find(({ value }) => value == data.value)
                                                  setFieldValue(
                                                    `deliveries[${index}].container_type`,
                                                    selectedObj.name
                                                  )
                                                  setFieldValue(
                                                    `deliveries[${index}].container_type_id`,
                                                    data.value
                                                  )
                                                }}
                                                options={containerType}
                                              />
                                              {touched.container_type &&
                                                errors.container_type ? (
                                                <div className="w3-small w3-text-red">
                                                  {props.t(
                                                    `container_type_id.error_msg.${errors.container_type_id}`
                                                  ) || errors.container_type_id}
                                                </div>
                                              ) : null}
                                            </FormUi.Field>
                                          </FormUi.Group>
                                        </Table.Cell>
                                      </Table.Row>

                                      <Table.Row>
                                        <Table.Cell colSpan="4">
                                          <FormUi.Group>
                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.t(
                                                  "delivery_form.container_seal_no.title"
                                                ) || "Container Seal No"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              width={3}
                                              error={
                                                touched.container_seal_no &&
                                                  errors.container_seal_no
                                                  ? true
                                                  : false
                                              }
                                              style={{
                                                width: "100%!important",
                                              }}
                                            >
                                              <Fieldmik
                                                component={MyInput}
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.container_seal_no.title"
                                                  ) || "Container Seal No."
                                                }
                                                name={`deliveries[${index}].container_seal_no`}
                                              />
                                              {touched.container_seal_no &&
                                                errors.container_seal_no ? (
                                                <div className="w3-small w3-text-red">
                                                  {props.t(
                                                    `container_seal_no.error_msg.${errors.container_seal_no}`
                                                  ) || errors.container_seal_no}
                                                </div>
                                              ) : null}
                                            </FormUi.Field>
                                            <FormUi.Field width={1} />
                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.t(
                                                  "delivery_form.shiping_line.title"
                                                ) || "Shipping Line"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <Dropdown
                                                clearable
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                search
                                                name={`deliveries[${index}].shipping_line_id`}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.shiping_line.title"
                                                  ) || "Shipping Line"
                                                }
                                                defaultValue={
                                                  values.deliveries[index]
                                                    .shipping_line_id
                                                }
                                                onChange={(name, data) =>
                                                  setFieldValue(
                                                    `deliveries[${index}].shipping_line_id`,
                                                    data.value
                                                  )
                                                }
                                                options={shipingline}
                                              />
                                            </FormUi.Field>
                                            <FormUi.Field width={1} />

                                            <FormUi.Field width={2}>
                                              <label className="labelName">
                                                {props.t(
                                                  "delivery_form.cha.title"
                                                ) || "CHA"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <Dropdown
                                                clearable
                                                style={{
                                                  width: "100%",
                                                  fontWeight: "normal",
                                                }}
                                                search
                                                name={`deliveries[${index}].cha_id`}
                                                selection
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.cha.title"
                                                  ) || "CHA"
                                                }
                                                defaultValue={
                                                  values.deliveries[index].cha_id
                                                }
                                                onChange={(name, data) =>
                                                  setFieldValue(
                                                    `deliveries[${index}].cha_id`,
                                                    data.value
                                                  )
                                                }
                                                options={cha}
                                              />
                                            </FormUi.Field>

                                          </FormUi.Group>
                                        </Table.Cell>
                                      </Table.Row>
                                    </>
                                  )}
                                {(props.moment == "import" ||
                                  props.moment == "export") && (
                                    <>
                                      <Table.Row>
                                        <Table.Cell colSpan="4">
                                          <FormUi.Group>

                                            <FormUi.Field
                                              width={2}

                                            >
                                              <label
                                                className="labelName"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {FEATURES.createOrderShowDemurageExpiration ? (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.do_no_expiration.title"
                                                    ) ||
                                                      "Demurrage Expiration"}{" "}
                                                  </>
                                                ) : (
                                                  <>
                                                    {props.t(
                                                      "delivery_form.demurrage_expiration.title"
                                                    ) ||
                                                      "Demurrage Expiration"}{" "}
                                                  </>
                                                )}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <DateData
                                                name={`deliveries[${index}].demurrage_expiration_date_t`}
                                                tname={`deliveries[${index}].demurrage_expiration_date`}
                                                autoComplete="off"
                                                // showTimeSelect
                                                timeFormat="HH:mm"
                                                popperClassName="dateTime"
                                                dateFormat="dd/MM/yyyy"
                                                timeIntervals={5}
                                                customInput={
                                                  <Input
                                                    icon="time"
                                                    // className="dateWidth"
                                                    iconPosition="left"
                                                  />
                                                }
                                              />
                                            </FormUi.Field>
                                            <FormUi.Field width={1} />
                                            <FormUi.Field
                                              width={2} >
                                              <label
                                                className="labelName"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.ata_date.title"
                                                ) || "ATA"}{" "}
                                                {/* {props.t(
                                              "delivery_form.delivery_date.title"
                                            ) || "Storage Expiration"}{" "} */}
                                                <MandatoryMark />
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <DateData
                                                name={`deliveries[${index}].ata_date_t`}
                                                tname={`deliveries[${index}].ata_date`}
                                                autoComplete="off"
                                                // showTimeSelect
                                                timeFormat="HH:mm"
                                                popperClassName="dateTime"
                                                dateFormat="dd/MM/yyyy"
                                                timeIntervals={5}
                                                customInput={
                                                  <Input
                                                    icon="time"
                                                    iconPosition="left"
                                                  />
                                                }
                                                error={
                                                  getIn(
                                                    errors,
                                                    `deliveries[${index}].ata_date`
                                                  ) &&
                                                    getIn(
                                                      touched,
                                                      `deliveries[${index}].ata_date`
                                                    )
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {
                                                <ErrorMessages
                                                  name={`deliveries[${index}].ata_date`}
                                                  trans={"delivery_form.ata_date"}
                                                />
                                              }
                                            </FormUi.Field>
                                            <FormUi.Field width={1} />
                                            <FormUi.Field
                                              width={2}
                                            >
                                              <label
                                                className="labelName"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.storage_expiration.title"
                                                ) || "Storage Expiration"}{" "}
                                                {/* <MandatoryMark /> */}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field width={3}>
                                              <DateData
                                                name={`deliveries[${index}].storage_expiration_date_t`}
                                                tname={`deliveries[${index}].storage_expiration_date`}
                                                autoComplete="off"
                                                timeFormat="HH:mm"
                                                popperClassName="dateTime"
                                                dateFormat="dd/MM/yyyy"
                                                timeIntervals={5}
                                                customInput={
                                                  <Input
                                                    icon="time"
                                                    iconPosition="left"
                                                  />
                                                }
                                              />
                                            </FormUi.Field>
                                          </FormUi.Group>
                                        </Table.Cell>
                                      </Table.Row>
                                      <Table.Row>

                                        {props.moment == "import" ? (
                                          <>
                                            <Table.Cell colSpan="4">
                                              <FormUi.Group>

                                                <FormUi.Field width={2}>
                                                  <label className="labelName">
                                                    {props.t(
                                                      "delivery_form.import_declaration_no.title"
                                                    ) ||
                                                      "import_declaration_no"}{" "}
                                                  </label>
                                                </FormUi.Field>
                                                <FormUi.Field
                                                  width={3}
                                                  error={
                                                    touched.import_declaration_no &&
                                                      errors.import_declaration_no
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  <Fieldmik
                                                    component={MyInput}
                                                    name={`deliveries[${index}].import_declaration_no`}
                                                  /* value={
                                                    values.import_declaration_no
                                                  } */
                                                  />
                                                  {touched.import_declaration_no &&
                                                    errors.import_declaration_no ? (
                                                    <div className="w3-small w3-text-red">
                                                      {props.t(
                                                        `delivery_form.import_declaration_no.error_msg.${errors.import_declaration_no}`
                                                      ) ||
                                                        errors.import_declaration_no}
                                                    </div>
                                                  ) : null}
                                                </FormUi.Field>
                                                <FormUi.Field width={1} />
                                                <FormUi.Field width={2}>
                                                  <label className="labelName">
                                                    {props.t(
                                                      "delivery_form.boarding_no.title"
                                                    ) || "boarding_no"}{" "}
                                                  </label>
                                                </FormUi.Field>
                                                <FormUi.Field
                                                  width={3}
                                                  error={
                                                    touched.boarding_no &&
                                                      errors.boarding_no
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  <Fieldmik
                                                    component={MyInput}
                                                    name={`deliveries[${index}].boarding_no`}
                                                  /* value={values.boarding_no} */
                                                  />
                                                  {touched.boarding_no &&
                                                    errors.boarding_no ? (
                                                    <div className="w3-small w3-text-red">
                                                      {props.t(
                                                        `delivery_form.boarding_no.error_msg.${errors.boarding_no}`
                                                      ) || errors.boarding_no}
                                                    </div>
                                                  ) : null}
                                                </FormUi.Field>
                                                <FormUi.Field width={6} />
                                              </FormUi.Group>
                                            </Table.Cell>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </Table.Row>
                                    </>
                                  )}
                                {props.moment == "export" || props.moment == "import" ? (
                                  <>
                                    <Table.Row>
                                      <Table.Cell colSpan="4">
                                        <FormUi.Group>
                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {
                                                props.moment == "import" ? 'CRO No' : props.t(
                                                  "delivery_form.do_no.title"
                                                ) || "DO No"
                                              }
                                            </label>
                                          </FormUi.Field>

                                          <FormUi.Field width={3}>
                                            <Fieldmik
                                              component={MyInput}
                                              style={{
                                                paddingTop: "5.5px",
                                                whiteSpace: "nowrap",
                                              }}
                                              name={`deliveries[${index}].do_no`}
                                            />
                                          </FormUi.Field>

                                          <FormUi.Field width={1} />

                                          <FormUi.Field width={2}>
                                            <label className="labelName">
                                              {props.moment == "import" ? 'CRO Date' : props.t(
                                                "delivery_form.do_date.title"
                                              ) || "DO Date"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>

                                          <FormUi.Field width={3}>
                                            <DateData
                                              name={`deliveries[${index}].do_validity_date_t`}
                                              tname={`deliveries[${index}].do_validity_date`}
                                              autoComplete="off"
                                              // showTimeSelect
                                              timeFormat="HH:mm"
                                              popperClassName="dateTime"
                                              dateFormat="dd/MM/yyyy"
                                              timeIntervals={5}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  // className="dateWidth"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                          </FormUi.Field>
                                          <FormUi.Field width={6} />
                                        </FormUi.Group>
                                      </Table.Cell>
                                    </Table.Row>

                                  </>
                                ) : null}
                                {!FEATURES.createOrderHideBillingPartyComponent ? (
                                  <>
                                    <Table.Row>
                                      {FEATURES.createOrderhideFields ? (
                                        <>
                                          <Table.Row>
                                            {LOCAL_STORAGE.billing_Party_Ids != "" ? (
                                              <Table.Cell colSpan="1">
                                                <FormUi.Field
                                                  width={3}
                                                  className="m-0 mb-2"
                                                >
                                                  <label
                                                    className="labelName"
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {props.t(
                                                      "delivery_form.customer_type.title"
                                                    ) || "Customer Type"}{" "}
                                                  </label>
                                                </FormUi.Field>
                                                <Dropdown
                                                  clearable
                                                  style={{
                                                    width: "100%",
                                                    fontWeight: "normal",
                                                  }}
                                                  search
                                                  selection
                                                  name={`deliveries[${index}].customer_type_id`}
                                                  placeholder={
                                                    props.t(
                                                      "delivery_form.customer_type.placeholder"
                                                    ) || "Customer Type"
                                                  }
                                                  defaultValue={
                                                    values.deliveries[index]
                                                      .customer_type_id
                                                  }
                                                  onChange={(name, data) =>
                                                    setFieldValue(
                                                      `deliveries[${index}].customer_type_id`,
                                                      data.value
                                                    )
                                                  }
                                                  options={customertype}
                                                />
                                                {touched.customer_type_id &&
                                                  errors.customer_type_id ? (
                                                  <div className="w3-small w3-text-red">
                                                    {props.t(
                                                      `proposed_vehicle_type.error_msg.${errors.customer_type_id}`
                                                    ) ||
                                                      errors.customer_type_id}
                                                  </div>
                                                ) : null}
                                              </Table.Cell>
                                            ) : null}
                                          </Table.Row>
                                        </>
                                      ) : null}
                                    </Table.Row>
                                  </>
                                ) : null}

                                <>
                                  <Table.Row>
                                    <Table.Cell colSpan="1">
                                      <h3 className="sub-heading-adjust">
                                        {FEATURES.billingPartyFreightDetailsTitle ?
                                          <>Billing Party Freight Details</>
                                          :
                                          <>Freight Details</>
                                        }
                                      </h3>
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">
                                      <Button
                                        basic
                                        color="green"
                                        type="button"
                                        size="mini"
                                        icon
                                        onClick={() => {
                                          evaluateFreightRate(
                                            values,
                                            setFieldValue,
                                            `deliveries[${index}].proposed_freight_rate`,
                                            `deliveries[${index}].actual_freight_rate`,
                                            `deliveries[${index}].final_freight_rate`,
                                            `deliveries[${index}].cft_kg_factor`,
                                            `deliveries[${index}].charged_weight`,
                                            `deliveries[${index}].cft_kg_enable`,
                                            `deliveries[${index}].final_rate`,
                                            `deliveries[${index}].charges`,
                                            index
                                          );
                                        }}
                                      >
                                        Evaluate Freight
                                      </Button>
                                    </Table.Cell>
                                  </Table.Row>
                                  <Table.Row>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.proposed_freight_rate.title"
                                          ) || "Proposed Freight Rate"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Input
                                          type="number"
                                          name={`deliveries[${index}].proposed_freight_rate`}
                                          //disabled={true}
                                          readonly
                                          value={
                                            values.deliveries[index]
                                              .proposed_freight_rate
                                          }
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t("delivery_form.uom.title") ||
                                            "UoM"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Dropdown
                                          name={`deliveries[${index}].uom`}
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          selection
                                          placeholder={
                                            props.t(
                                              "delivery_form.uom.title"
                                            ) || "Unit Of Measurement"
                                          }
                                          options={uomValues}
                                          defaultValue={"ton"}
                                          value={values.deliveries[index].uom}
                                          onChange={(name, data) => {
                                            let uom_name = uomValues.find((uom)=> uom.value == data.value)?.text
                                            setFieldValue(
                                              `deliveries[${index}].uom`, data.value
                                            );
                                            setFieldValue(
                                              `deliveries[${index}].uom_name`, uom_name
                                            );
                                            let multiplyFactor = 0, actualValue = 0;
                                            let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;

                                            if (values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name) {
                                              if (uom_name.toUpperCase() === "TRIP") {
                                                actualValue = actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`, actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                              } else if (uom_name.toUpperCase() === "KG") {
                                                multiplyFactor = FEATURES.weightInTonCustomers ? (Number(values.deliveries[index].charged_weight) * 1000) :values.deliveries[index].charged_weight;
                                                actualValue = multiplyFactor * actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`, actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                              } else if (uom_name.toUpperCase() === "TON") {
                                                multiplyFactor = FEATURES.weightInTonCustomers ? values.deliveries[index].charged_weight : (Number(values.deliveries[index].charged_weight) / 1000);
                                                actualValue = multiplyFactor * actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`, actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                              } else if (uom_name.toUpperCase() === "KM") {
                                                if (props?.bdistance) {
                                                  multiplyFactor = props.bdistance;
                                                  actualValue = multiplyFactor * actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`, actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                                } else {
                                                  cogoToast.warn('No Budgested Distance in route.')
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`, 0
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + 0)
                                                }
                                              }else if (uom_name.toUpperCase() === "PER TON PER KM") {
                                                if (props?.bdistance && values?.deliveries[index]?.charged_weight) {
                                                    multiplyFactor = FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : Number(values.deliveries[index].charged_weight)/1000;
                                                    let distance = props.bdistance;
                                                    actualValue = multiplyFactor * actualFreightValue * distance;
                                                    setFieldValue(
                                                      `deliveries[${index}].final_freight_rate`, actualValue
                                                    );
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                                } else {
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`, 0
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + 0)
                                                }
                                              }
                                               else if (
                                                uom_name.toUpperCase() === "PER CASE"
                                              ) {
                                                multiplyFactor = values.deliveries[index].total_quantity;
                                                actualValue = multiplyFactor * actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`, actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                              } else if (uom_name.toUpperCase() === "CFT" || uom_name.toUpperCase() === "PER CFT KG") {
                                                let multiplyFactor = 0, actualValue = 0;
                                                let tempVolume = 0;

                                                let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;

                                                for (
                                                  let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                ) {
                                                  tempVolume = tempVolume +
                                                    values?.deliveries?.[index]?.products[indx].quantity *
                                                    values?.deliveries?.[index]?.products[indx].breadth *
                                                    values?.deliveries?.[index]?.products[indx].breadth *
                                                    values?.deliveries?.[index]?.products[indx].height;
                                                }

                                                if (values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG" && values?.deliveries?.[index]?.cft_kg_factor && +values.deliveries[index].cft_kg_factor > 0) {
                                                  multiplyFactor = tempVolume * +values.deliveries[index].cft_kg_factor
                                                  setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);

                                                } else {
                                                  multiplyFactor = tempVolume
                                                }

                                                actualValue = multiplyFactor * actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`, actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                              }
                                            }
                                            // setFieldValue(`deliveries[${index}].final_rate`, values.deliveries[index].charges + +values.deliveries[index].final_freight_rate);                                
                                          }}
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                    {values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG" ?
                                      <Table.Cell colSpan="1">
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.cft_factor.title"
                                            ) || "CFT KG Factor"}{" "}
                                            {/* <MandatoryMark /> */}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field className="m-0 mb-2">
                                          <Input
                                            type="number"
                                            name={`deliveries[${index}].cft_kg_factor`}
                                            disabled={disabledCftFactor}
                                            value={values.deliveries[index].cft_kg_factor}
                                            onChange={(event) => {
                                              setFieldValue(
                                                `deliveries[${index}].cft_kg_factor`,
                                                event.target.value
                                              );


                                              if (values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG"
                                              ) {
                                                let multiplyFactor = 0, actualValue = 0;
                                                let tempVolume = 0;
                                                let actualFreightValue =
                                                  values?.deliveries?.[index]?.actual_freight_rate;

                                                for (
                                                  let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                ) {
                                                  if (
                                                    values?.deliveries?.[index]?.products[indx].quantity &&
                                                    values?.deliveries?.[index]?.products[indx].length &&
                                                    values?.deliveries?.[index]?.products[indx].breadth &&
                                                    values?.deliveries?.[index]?.products[indx].height
                                                  ) {
                                                    tempVolume = tempVolume +
                                                      values.deliveries[index].products[indx].quantity *
                                                      values.deliveries[index].products[indx].length *
                                                      values.deliveries[index].products[indx].breadth *
                                                      values?.deliveries[index].products[indx].height;
                                                  }
                                                }

                                                if (
                                                  values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG" &&
                                                  event.target.value > 0
                                                ) {
                                                  multiplyFactor = tempVolume * +event.target.value;
                                                  setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                } else {
                                                  multiplyFactor = tempVolume;
                                                }

                                                actualValue = multiplyFactor * actualFreightValue;
                                                setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue)
                                              }
                                            }}
                                          />
                                        </FormUi.Field>
                                      </Table.Cell>
                                      : null}
                                  </Table.Row>

                                  <Table.Row>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.actual_freight_rate.title"
                                          ) || "Actual Freight Rate"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Input
                                          type="number"
                                          name={`deliveries[${index}].actual_freight_rate`}
                                          onChange={(name, data) => {
                                            setFieldValue(
                                              `deliveries[${index}].actual_freight_rate`, data.value
                                            );

                                            let actualValue = 0;
                                            if (values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name) {
                                              if (values.deliveries[index].uom_name.toUpperCase() === "TRIP") {
                                                actualValue = +data.value;
                                                setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue)
                                              } else if (values.deliveries[index].uom_name.toUpperCase() === "KG") {
                                                let multiplyFactor;
                                                multiplyFactor = FEATURES.weightInTonCustomers ? (Number(values.deliveries[index].charged_weight) * 1000) : Number(values.deliveries[index].charged_weight);
                                                actualValue = multiplyFactor * data.value;
                                                setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue)
                                              } else if (values.deliveries[index].uom_name.toUpperCase() === "TON") {
                                                let multiplyFactor;
                                                multiplyFactor = FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : (Number(values.deliveries[index].charged_weight) / 1000);
                                                actualValue = multiplyFactor * data.value;
                                                setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue)
                                              } else if (values.deliveries[index].uom_name.toUpperCase() === "KM") {
                                                let multiplyFactor;
                                                if (props?.bdistance) {
                                                  multiplyFactor = props.bdistance;
                                                  actualValue = multiplyFactor * data.value;
                                                  setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue);
                                                } else {
                                                  cogoToast.warn('No Budgested Distance in route.')
                                                  setFieldValue(`deliveries[${index}].final_freight_rate`, 0);
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + 0);
                                                }
                                              }else if (values.deliveries[index].uom_name.toUpperCase() === "PER TON PER KM") {
                                                let multiplyFactor;
                                                if (props?.bdistance && values.deliveries[index].charged_weight) {
                                                  multiplyFactor = props.bdistance;
                                                  let weight_in_ton = values.deliveries[index].charged_weight && (FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : Number(values.deliveries[index].charged_weight)/1000)
                                                  actualValue = multiplyFactor * data.value * weight_in_ton;
                                                  setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue);
                                                } else {
                                                  setFieldValue(`deliveries[${index}].final_freight_rate`, 0);
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + 0);
                                                }
                                              } else if (values.deliveries[index].uom_name.toUpperCase() === "PER CASE") {
                                                let multiplyFactor;
                                                multiplyFactor = values.deliveries[index].total_quantity;
                                                actualValue = multiplyFactor * data.value;
                                                setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue);
                                              } else if (
                                                values.deliveries[index].uom_name.toUpperCase() === "CFT" || values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG"
                                              ) {
                                                let multiplyFactor = 0, actualValue = 0;
                                                let tempVolume = 0;

                                                let actualFreightValue = data.value;

                                                for (
                                                  let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                ) {
                                                  tempVolume = tempVolume +
                                                    values?.deliveries?.[index]?.products[indx].quantity *
                                                    values?.deliveries?.[index]?.products[indx].breadth *
                                                    values?.deliveries?.[index]?.products[indx].length *
                                                    values?.deliveries?.[index]?.products[indx].height;
                                                }

                                                if (values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() === "PER CFT KG" && values?.deliveries?.[index]?.cft_kg_factor && +values.deliveries[index].cft_kg_factor > 0) {
                                                  multiplyFactor = tempVolume * +values.deliveries[index].cft_kg_factor
                                                  setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                } else {
                                                  multiplyFactor = tempVolume
                                                }

                                                actualValue = multiplyFactor * actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`, actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, values.deliveries[index].charges + +actualValue);

                                              }
                                            }
                                          }}
                                          value={
                                            values.deliveries[index]
                                              .actual_freight_rate
                                          }
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.final_freight_rate.title"
                                          ) || "Final Freight Rate"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Input
                                          type="number"
                                          name={`deliveries[${index}].final_freight_rate`}
                                          //disabled={true}
                                          readonly
                                          /* onChange={(name, data) => {
                                            setFieldValue(`deliveries[${index}].final_freight_rate`, data.value);
                                            setFieldValue(`deliveries[${index}].actual_freight_rate`, data.value);
                                          }} */
                                          value={
                                            values.deliveries[index]
                                              .final_freight_rate
                                          }
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                  </Table.Row>
                                  <div className='col-md-12 mb-4 mt-4'>
                                    <TableB size='sm' className='ui unstackable table'>
                                      <thead>
                                        <tr className='tr-heading'>
                                          <td> Other Charges</td>
                                          <td>Amount</td>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <FieldArray
                                          name={`deliveries[${index}].lr_other_charges`}
                                          render={(arrayHelpers) => {
                                            values.deliveries[index].charges = 0
                                            return (
                                              <>
                                                {values.deliveries[index].lr_other_charges && values.deliveries[index].lr_other_charges.map(
                                                  (object, ind) => {
                                                    values.deliveries[index].charges +=
                                                      +object.charges
                                                    return (
                                                      <>
                                                        <tr key={index}>
                                                          <td style={{ width: '25%' }}>
                                                            <Fieldmik
                                                              size='mini'
                                                              className='labelName'
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].psId`}
                                                              advanceMode={true}
                                                              component={MyPSLineItem}
                                                              advanceType="Vendor"
                                                              id={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                            />
                                                            <ErrorMessage
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                            />
                                                          </td>
                                                          <td>
                                                            <Fieldmik
                                                              size='mini'
                                                              type='number'
                                                              min='1'
                                                              component={MyNormalInput}
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                              onBlur={() => {
                                                                if (values.deliveries[index].charges) {
                                                                  setFieldValue(`deliveries[${index}].final_rate`, Number(values.deliveries[index].final_freight_rate) + +values.deliveries[index].charges)
                                                                }
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                            />

                                                          </td>
                                                          <td>
                                                            <Button
                                                              basic
                                                              color="red"
                                                              type="button"
                                                              id={ind}
                                                              onClick={(e) => {
                                                                setFieldValue(`deliveries[${index}].final_rate`, Number(values.deliveries[index].final_rate) - +object.charges)
                                                                arrayHelpers.remove(ind);
                                                              }}
                                                              size="mini"
                                                              className='ml-2 w3-tiny'
                                                              variant='outline-danger'
                                                            >
                                                              <i className='fa fa-trash' color="red"></i>
                                                            </Button>
                                                          </td>
                                                        </tr>
                                                      </>
                                                    )
                                                  }
                                                )}
                                                <tr>
                                                  <td>Total</td>
                                                  <td>{values.deliveries[index].charges}</td>
                                                </tr>
                                                <Button
                                                  basic
                                                  color="blue"
                                                  className="m-2"
                                                  type="button"
                                                  size="mini"
                                                  onClick={() =>
                                                    arrayHelpers.push({
                                                      charge_type_id: '',
                                                      charges: '',
                                                    })
                                                  }
                                                >
                                                  + Add More Expense
                                                </Button>
                                              </>
                                            )
                                          }}
                                        />
                                      </tbody>
                                    </TableB>
                                    <FormUi.Field className="m-0 mb-2">
                                      <label className="labelName">
                                        {"Final Rate"}{" "}
                                        {/* <MandatoryMark /> */}
                                      </label>
                                    </FormUi.Field>
                                    <FormUi.Field className="m-0 mb-2">
                                      <Input
                                        type="number"
                                        name={`deliveries[${index}].final_rate`}
                                        //disabled={true}
                                        readonly
                                        /* onChange={(name, data) => {
                                          setFieldValue(`deliveries[${index}].final_freight_rate`, data.value);
                                          setFieldValue(`deliveries[${index}].actual_freight_rate`, data.value);
                                        }} */
                                        value={
                                          values.deliveries[index]
                                            .final_rate
                                        }
                                      />
                                    </FormUi.Field>
                                  </div>
                                </>
                                <Table.Row>
                                  <Table.Cell colSpan="1">
                                    <FormUi.Field
                                      className="m-0 mb-2"
                                    >
                                      {FEATURES.lineItemsTitleForRemarks ?
                                        <label className="labelName">
                                          {props.t("delivery_form.remarks1166.title") ||
                                            "STO/SO/RGP-NRGP/LineItems"}{" "}
                                        </label>
                                        :
                                        <label className="labelName">
                                          {props.t("delivery_form.remarks.title") ||
                                            "Remarks"}{" "}
                                        </label>
                                      }
                                    </FormUi.Field>


                                    <Fieldmik
                                      component="textarea"
                                      rows="2"
                                      name={`deliveries[${index}].remarks`}
                                      value={values.deliveries[index].remarks}
                                    />
                                  </Table.Cell>

                                  <Table.Cell colSpan="1">
                                    <label className="labelName">
                                      {"Physical LR"}{" "}
                                    </label>
                                    <input
                                      type="file"
                                      accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                      onChange={(event) => {
                                        if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                          props.setFileDataLR("Physical LR", event.currentTarget.files[0], index)
                                          setEnablePhysicalLR(false)
                                        } else {
                                          cogoToast.error(INVALID_FILE_TYPE)
                                          setEnablePhysicalLR(true)
                                        }
                                      }}
                                    />
                                    <div className="d-flex align-items-center">
                                      <Button
                                        className="docsButton"
                                        size="mini"
                                        basic
                                        type="button"
                                        onClick={() => {
                                          props.setFileDataLR("Physical LR", [], index)
                                          cogoToast.error(FILE_DELETED)
                                        }
                                        }
                                        color="red"
                                        icon
                                      >
                                        <Icon name="trash" />
                                      </Button>
                                      <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                    </div>
                                  </Table.Cell>

                                  <Table.Cell colSpan="1">
                                    <label className="labelName">
                                      {"Other LR"}{" "}
                                    </label>

                                    <input
                                      type="file"
                                      accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                      onChange={(event) => {
                                        if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                          props.setFileDataLR("Other LR", event.currentTarget.files[0], index)
                                          setEnableOtherDocs(false)
                                        } else {
                                          cogoToast.error(INVALID_FILE_TYPE)
                                          setEnableOtherDocs(true)
                                        }
                                      }}
                                    />
                                    <div className="d-flex align-items-center">
                                      <Button
                                        className="docsButton"
                                        size="mini"
                                        basic
                                        type="button"
                                        onClick={() => {
                                          props.setFileDataLR("Other LR", [], index)
                                          cogoToast.error(FILE_DELETED)
                                        }
                                        }
                                        color="red"
                                        icon
                                      >
                                        <Icon name="trash" />
                                      </Button>
                                      <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                    </div>
                                  </Table.Cell>
                                </Table.Row>

                                <Table.Row key={`Invoice` + index}>
                                  <Table.Cell colSpan="9">
                                    <FieldArray
                                      key={`invoice_form` + index}
                                      name={`deliveries[${index}].invoices`}
                                      render={(deliveryInvoices) => (
                                        <React.Fragment key={index}>
                                          {values.deliveries[
                                            index
                                          ].invoices.map((invoice, i) => (
                                            <Table unstackable key={i}>
                                              <Table.Header>
                                                <Table.Row colSpan="9">
                                                  <Table.HeaderCell colSpan="6">
                                                    {props.t(
                                                      "invoice_form.title"
                                                    ) || "Invoice"}{" "}
                                                    {i + 1}
                                                  </Table.HeaderCell>
                                                  <Table.HeaderCell textAlign="right">
                                                    {i !== 0 ? (
                                                      <Button
                                                        basic
                                                        color="red"
                                                        type="button"
                                                        onClick={() =>
                                                          deliveryInvoices.remove(
                                                            i
                                                          )
                                                        }
                                                        size="mini"
                                                        icon
                                                      >
                                                        {" "}
                                                        <Icon
                                                          name="trash"
                                                          color="red"
                                                        />{" "}
                                                      </Button>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </Table.HeaderCell>
                                                </Table.Row>
                                              </Table.Header>
                                              <Table.Body>
                                                <Grid columns={3} className='m-2'>
                                                  <Grid.Column>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_code.title"
                                                        ) || "Invoice No"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_no`}
                                                      type="text"
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_no`}
                                                        trans={
                                                          "invoice_form.invoice_code"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>

                                                  <Grid.Column>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_reference_no"
                                                        ) || "Invoice Reference Number"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_reference_no`}
                                                      type="text"
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_reference_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_reference_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_reference_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_reference_no`}
                                                        trans={
                                                          "invoice_form.invoice_reference_no"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>

                                                  <Grid.Column>
                                                    <Fieldmik
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_amount.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_amount`}
                                                      type="number"
                                                      min={0}
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_amount
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_amount`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_amount`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_amount`}
                                                        trans={
                                                          "invoice_form.invoice_amount"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <label>
                                                      {props.t(
                                                        "invoice_form.invoice_date.title"
                                                      ) || "Invoice Date"}
                                                    </label>
                                                    <br></br>
                                                    <DateData
                                                      name={`deliveries[${index}].invoices[${i}].invoice_date_t`}
                                                      tname={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                      autoComplete="off"
                                                      maxDate={moment().toDate()}
                                                      // showTimeSelect
                                                      timeFormat="HH:mm"
                                                      popperClassName="dateTime"
                                                      dateFormat="dd/MM/yyyy HH:mm"
                                                      timeIntervals={5}
                                                      customInput={
                                                        <Input
                                                          icon="time"
                                                          // className="dateWidth"
                                                          iconPosition="left"
                                                        />
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_date`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_date`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                        trans={
                                                          "invoice_form.invoice_date"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <Fieldmik
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        // width: "125px"
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_quantity.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_quantity`}
                                                      type="number"
                                                      min={0}
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_quantity
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_quantity`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_quantity`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_quantity`}
                                                        trans={
                                                          "invoice_form.invoice_quantity"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        "Eway Bill No"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].eway_bill_no`}
                                                      maxLength={12}
                                                      type='number'
                                                      // onChange={(
                                                      //   name,
                                                      //   data
                                                      // ) => {
                                                      //   setFieldValue(
                                                      //     `deliveries[${index}].invoices[${i}].eway_bill_no`,
                                                      //     data.value
                                                      //   );
                                                      // }}
                                                      //defaultValue={
                                                      value={values.deliveries[index].invoices[i].eway_bill_no ? values.deliveries[index].invoices[i].eway_bill_no : ''
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].eway_bill_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].eway_bill_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      getIn(
                                                        errors,
                                                        `deliveries[${index}].invoices[${i}].eway_bill_no`
                                                      ) &&
                                                        getIn(
                                                          touched,
                                                          `deliveries[${index}].invoices[${i}].eway_bill_no`
                                                        ) ? <div style={{ color: 'red' }}>{INVALID_FIELDS.INVALID_EWAYBILL_NO}</div> : null
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <label>
                                                      Eway Bill Expiry Date
                                                    </label>
                                                    <br></br>
                                                    <DateData
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].eway_bill_expirydate_t`}
                                                      tname={`deliveries[${index}].invoices[${i}].eway_bill_expirydate`}
                                                      autoComplete="off"
                                                      //maxDate={moment().toDate()}
                                                      minDate={moment().toDate()}
                                                      filterDate={(date) => {
                                                        return moment() < date;
                                                      }}
                                                      // showTimeSelect
                                                      // timeFormat="HH:mm"
                                                      popperClassName="date"
                                                      dateFormat="dd/MM/yyyy"
                                                      timeIntervals={5}
                                                      value={values.deliveries[index].invoices[i].eway_bill_expirydate ? moment(values.deliveries[index].invoices[i].eway_bill_expirydate).format(DATE_DDMMyyyy) : ''}
                                                      customInput={
                                                        <Input
                                                          icon="time"
                                                          // className="dateWidth"
                                                          iconPosition="left"
                                                        />
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].eway_bill_expirydate`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].eway_bill_expirydate`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].eway_bill_expirydate`}
                                                        trans={
                                                          "invoice_form.eway_bill_expirydate"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <label>
                                                      Invoice Copy
                                                    </label>
                                                    <input
                                                      type="file"
                                                      accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                      onChange={(event) => {
                                                        if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                          props.setFileDataInvoices("Invoice Copy", event.currentTarget.files[0], index, i)
                                                          setEnableInvoiceDoc(false)
                                                        } else {
                                                          cogoToast.error(INVALID_FILE_TYPE)
                                                          setEnableInvoiceDoc(true)
                                                        }
                                                      }}
                                                    />
                                                    <div className="d-flex align-items-center">
                                                      <Button
                                                        className="docsButton"
                                                        size="mini"
                                                        basic
                                                        type="button"
                                                        onClick={() => {
                                                          props.setFileDataInvoices("Invoice Copy", [], index, i)
                                                          cogoToast.error(FILE_DELETED)
                                                        }
                                                        }
                                                        color="red"
                                                        icon
                                                      >
                                                        <Icon name="trash" />
                                                      </Button>
                                                      <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                    </div>
                                                  </Grid.Column>

                                                  <Grid.Column>
                                                    <label>
                                                      Eway Bill Copy
                                                    </label>
                                                    <input
                                                      type="file"
                                                      accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                      onChange={(event) => {
                                                        if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                          props.setFileDataInvoices("Eway Bill Copy", event.currentTarget.files[0], index, i)
                                                          setEnableEwayDoc(false)
                                                        } else {
                                                          cogoToast.error(INVALID_FILE_TYPE)
                                                          setEnableEwayDoc(true)
                                                        }
                                                      }}
                                                    />
                                                    <div className="d-flex align-items-center">
                                                      <Button
                                                        className="docsButton"
                                                        size="mini"
                                                        basic
                                                        type="button"
                                                        onClick={() => {
                                                          props.setFileDataInvoices("Eway Bill Copy", [], index, i)
                                                          cogoToast.error(FILE_DELETED)
                                                        }
                                                        }
                                                        color="red"
                                                        icon
                                                      >
                                                        <Icon name="trash" />
                                                      </Button>
                                                      <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                    </div>
                                                  </Grid.Column>




                                                  {props.moment == "import" || props.moment == "export" ? (
                                                    <>
                                                      <Grid.Column>
                                                        <Fieldmik
                                                          component={MyInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                          }}
                                                          label={
                                                            props.t(
                                                              "invoice_form.boe_no.title"
                                                            ) || "BOE No"
                                                          }
                                                          name={`deliveries[${index}].invoices[${i}].boe_no`}
                                                          type="text"
                                                        />
                                                      </Grid.Column>

                                                      <Grid.Column>
                                                        <label>
                                                          {props.t(
                                                            "invoice_form.boe_date.title"
                                                          ) || "Invoice Date"}
                                                        </label>
                                                        <br></br>
                                                        <DateData
                                                          name={`deliveries[${index}].invoices[${i}].boe_date`}
                                                          tname={`deliveries[${index}].invoices[${i}].boe_date`}
                                                          autoComplete="off"
                                                          // showTimeSelect
                                                          timeFormat="HH:mm"
                                                          popperClassName="dateTime"
                                                          dateFormat="dd/MM/yyyy HH:mm"
                                                          timeIntervals={5}
                                                          customInput={
                                                            <Input
                                                              icon="time"
                                                              // className="dateWidth"
                                                              iconPosition="left"
                                                            />
                                                          }
                                                        />
                                                      </Grid.Column>

                                                      <Grid.Column>
                                                        <Fieldmik
                                                          component={MyInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                          }}
                                                          label={
                                                            props.t(
                                                              "invoice_form.bl_no.title"
                                                            ) || "Bl_No"
                                                          }
                                                          name={`deliveries[${index}].invoices[${i}].bl_no`}
                                                          type="text"
                                                          min={0}
                                                          defaultValue={
                                                            values.deliveries[
                                                              index
                                                            ].invoices[i].bl_no
                                                          }
                                                          error={
                                                            getIn(
                                                              errors,
                                                              `deliveries[${index}].invoices[${i}].bl_no`
                                                            ) &&
                                                              getIn(
                                                                touched,
                                                                `deliveries[${index}].invoices[${i}].bl_no`
                                                              )
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].invoices[${i}].bl_no`}
                                                            trans={
                                                              "invoice_form.bl_no"
                                                            }
                                                          />
                                                        }
                                                      </Grid.Column>
                                                    </>
                                                  ) : null}

                                                </Grid>
                                              </Table.Body>
                                            </Table>
                                          ))}
                                          <Button
                                            basic
                                            color="blue"
                                            className="m-2"
                                            type="button"
                                            onClick={() =>
                                              deliveryInvoices.push({
                                                invoice_code: "",
                                                invoice_date: "",
                                                invoice_quantity: "",
                                                invoice_amount: "",
                                                eway_bill_no: "",
                                                eway_bill_expirydate: ""
                                              })
                                            }
                                            size="mini"
                                          >
                                            {" "}
                                            {props.t(
                                              "invoice_form.action_button.add_more_invoice"
                                            ) || "Add More Invoices"}{" "}
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    />
                                  </Table.Cell>
                                </Table.Row>

                                <Table.Row key={`product` + index}>
                                  <Table.Cell colSpan="6">
                                    <FieldArray
                                      key={`product_form` + index}
                                      name={`deliveries[${index}].products`}
                                      render={(deliveryProducts) => (
                                        <React.Fragment key={index}>
                                          {values.deliveries[
                                            index
                                          ].products.map((product, i) => (
                                            <Table unstackable key={i}>
                                              <Table.Header>
                                                <Table.Row>
                                                  <Table.HeaderCell colSpan="4">
                                                    {props.t(
                                                      "product_form.title"
                                                    ) || "Product"}{" "}
                                                    {i + 1}
                                                  </Table.HeaderCell>
                                                  <Table.HeaderCell textAlign="right">
                                                    {i !== 0 ? (
                                                      <Button
                                                        basic
                                                        color="red"
                                                        type="button"
                                                        onClick={() =>
                                                          deliveryProducts.remove(
                                                            i
                                                          )
                                                        }
                                                        size="mini"
                                                        icon
                                                      >
                                                        {" "}
                                                        <Icon
                                                          name="trash"
                                                          color="red"
                                                        />{" "}
                                                      </Button>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </Table.HeaderCell>
                                                </Table.Row>
                                              </Table.Header>
                                              <Table.Body>
                                                <Table.Row>
                                                  {props.moment ==
                                                    "primary" ? (
                                                    <>
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.product_category_id.title"
                                                          ) ||
                                                            "Product Category"}
                                                        </label>
                                                        <Dropdown
                                                          error={
                                                            getIn(
                                                              errors,
                                                              `deliveries[${index}].products[${i}].product_category_id`
                                                            ) &&
                                                              getIn(
                                                                touched,
                                                                `deliveries[${index}].products[${i}].product_category_id`
                                                              )
                                                              ? true
                                                              : false
                                                          }
                                                          name={`deliveries[${index}].products[${i}].product_category_id`}
                                                          placeholder={
                                                            props.t(
                                                              "product_form.product_category_id.placeholder"
                                                            ) ||
                                                            "Product Category"
                                                          }
                                                          clearable
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                          selection
                                                          search
                                                          onChange={(
                                                            name,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].product_category_id`,
                                                              data.value
                                                            );
                                                          }}
                                                          defaultValue={
                                                            values.deliveries[
                                                              index
                                                            ].products[i]
                                                              .product_category_id
                                                          }
                                                          options={
                                                            serviceCateogyList
                                                          }
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].product_category_id`}
                                                            trans={
                                                              "product_form.product_category_id"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.product_code.title"
                                                      ) || "Product Code"}
                                                    </label>
                                                    <Dropdown
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_code`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_code`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_code`}
                                                      placeholder={
                                                        props.t(
                                                          "product_form.product_code.placeholder"
                                                        ) || "Product Code"
                                                      }
                                                      clearable
                                                      style={{ width: "100%" }}
                                                      selection
                                                      search
                                                      onChange={(name, data) =>
                                                        setProductCodeAndProductName(
                                                          name,
                                                          data,
                                                          `deliveries[${index}].products[${i}].product_name`
                                                        )
                                                      }
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .products[i]
                                                          .product_code
                                                      }
                                                      options={products}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_code`}
                                                        trans={
                                                          "product_form.product_code"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.product_name"
                                                      ) || "Product Name"}
                                                    </label>
                                                    <Fieldmik
                                                      type="text"
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "product_form.product_name"
                                                        ) || "Product Name"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_name`}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_name`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_name`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_name`}
                                                        trans={
                                                          "product_form.product_name"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "product_form.quantity.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].quantity`}
                                                      type="number"
                                                      value={
                                                        values.deliveries[index]
                                                          .products[i].quantity
                                                      }
                                                      min={0}
                                                      onBlur={(name, data) => {

                                                        if (values?.deliveries?.[index]?.uom_name && (values?.deliveries?.[index]?.uom_name.toUpperCase() == "CFT" || values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG")) {
                                                          let multiplyFactor = 0, actualValue = 0;
                                                          let tempVolume = 0;

                                                          let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;

                                                          for (
                                                            let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                          ) {
                                                            tempVolume = tempVolume +
                                                              values?.deliveries?.[index]?.products[indx].quantity *
                                                              values?.deliveries?.[index]?.products[indx]["length"] *
                                                              values?.deliveries?.[index]?.products[indx].breadth *
                                                              values?.deliveries?.[index]?.products[indx].height;
                                                          }

                                                          if (values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG" && values?.deliveries?.[index]?.cft_kg_factor && +values.deliveries[index].cft_kg_factor > 0) {
                                                            multiplyFactor = tempVolume * +values.deliveries[index].cft_kg_factor
                                                            setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                          } else {
                                                            multiplyFactor = tempVolume
                                                          }
                                                          actualValue = multiplyFactor * actualFreightValue;
                                                          setFieldValue(
                                                            `deliveries[${index}].final_freight_rate`, actualValue
                                                          );
                                                          setFieldValue(`deliveries[${index}].final_rate`, values.deliveries[index].charges + +actualValue);

                                                        }
                                                        if (!alloted_orders_quantity) {
                                                          setFieldValue(
                                                            `deliveries[${index}].total_quantity`, getCounts(values.deliveries[index].products)
                                                          );
                                                        }
                                                      }}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].quantity`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].quantity`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].quantity`}
                                                        trans={
                                                          "product_form.quantity"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  {props.moment ==
                                                    "primary" ? (
                                                    <>
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.packaging_type_id.title"
                                                          ) || "Packaging Type"}
                                                        </label>
                                                        <Dropdown
                                                          error={
                                                            getIn(
                                                              errors,
                                                              `deliveries[${index}].products[${i}].packaging_type_id`
                                                            ) &&
                                                              getIn(
                                                                touched,
                                                                `deliveries[${index}].products[${i}].packaging_type_id`
                                                              )
                                                              ? true
                                                              : false
                                                          }
                                                          name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                          placeholder={
                                                            props.t(
                                                              "product_form.packaging_type_id.placeholder"
                                                            ) || "Product Code"
                                                          }
                                                          clearable
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                          selection
                                                          search
                                                          onChange={(
                                                            name,
                                                            data
                                                          ) =>
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].packaging_type_id`,
                                                              data.value
                                                            )
                                                          }
                                                          // defaultValue={`${values.deliveries[index].products[i].packaging_type_id}`} [Removed as QA Aniket Pointed it out]
                                                          options={packageType}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                            trans={
                                                              "product_form.packaging_type_id"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                </Table.Row>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        // width: "155px"
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_code.title"
                                                        ) || "Invoice No"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].invoice_no`}
                                                      type="text"
                                                      value={
                                                        values.deliveries[index]
                                                          .products[i]
                                                          .invoice_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].invoice_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].invoice_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].invoice_no`}
                                                        trans={
                                                          "invoice_form.invoice_code"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>

                                                  {
                                                    FEATURES.transactionDetailsEnabled &&
                                                    <>
                                                    <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "transaction_amount.title"
                                                        ) || "Transaction Amount"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].transaction_amount`}
                                                      type="number"
                                                      value={
                                                        values.deliveries[index]
                                                          .products[i]
                                                          .transaction_amount
                                                      }
                                                      min={0}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].transaction_amount`}
                                                      />
                                                    }
                                                  </Table.Cell>

                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "transaction_quantity.title"
                                                        ) || "Transaction Quantity"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].transaction_quantity`}
                                                      type="number"
                                                      value={
                                                        values.deliveries[index]
                                                          .products[i]
                                                          .transaction_quantity
                                                      }
                                                      min={0}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].transaction_quantity`}
                                                      />
                                                    }
                                                  </Table.Cell>
                                                    </>
                                                  }

                                                  {values.service_type_id == 2 || values?.deliveries?.[index].service_type_id ==
                                                    2 ||
                                                   (values?.deliveries?.[index]?.uom_name &&
                                                    (values?.deliveries?.[index]?.uom_name.toUpperCase() == "CFT" ||
                                                    values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG")) ? (
                                                    <>
                                                      <Table.Cell>
                                                        <Fieldmik
                                                          component={MyNumInput}
                                                          label={
                                                            props.t(
                                                              "product_form.length"
                                                            ) || "Length"
                                                          }
                                                          placeholder={props.t(
                                                            "product_form.lbhPlaceholder"
                                                          )}
                                                          name={`deliveries[${index}].products[${i}].length`}
                                                          type="number"
                                                          // type="number"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].products[i].length
                                                          }
                                                          min={0}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            // width: "155px"
                                                          }}
                                                          onBlur={(name, data) => {

                                                            if (values?.deliveries?.[index]?.uom_name && (values?.deliveries?.[index]?.uom_name.toUpperCase() == "CFT" || values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG")) {
                                                              let multiplyFactor = 0, actualValue = 0;
                                                              let tempVolume = 0;

                                                              let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;

                                                              for (
                                                                let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                              ) {
                                                                tempVolume = tempVolume +
                                                                  values?.deliveries?.[index]?.products[indx].quantity *
                                                                  values?.deliveries?.[index]?.products[indx]["length"] *
                                                                  values?.deliveries?.[index]?.products[indx].breadth *
                                                                  values?.deliveries?.[index]?.products[indx].height;
                                                              }

                                                              if (values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG" && values?.deliveries?.[index]?.cft_kg_factor && +values.deliveries[index].cft_kg_factor > 0) {
                                                                multiplyFactor = tempVolume * +values.deliveries[index].cft_kg_factor
                                                                setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                              } else {
                                                                multiplyFactor = tempVolume
                                                              }

                                                              actualValue = multiplyFactor * actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`, actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, values.deliveries[index].charges + +actualValue);
                                                            }
                                                          }}
                                                          onChange={(
                                                            value,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].length`,
                                                              data.value);
                                                          }}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].length`}
                                                            trans={
                                                              "product_form.length"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                      <Table.Cell>
                                                        <Fieldmik
                                                          component={MyNumInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            // width: "155px"
                                                          }}
                                                          type="number"
                                                          label={
                                                            props.t(
                                                              "product_form.breadth"
                                                            ) || "Breadth"
                                                          }
                                                          placeholder={props.t(
                                                            "product_form.lbhPlaceholder"
                                                          )}
                                                          name={`deliveries[${index}].products[${i}].breadth`}
                                                          // type="number"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].products[i]
                                                              .breadth
                                                          }
                                                          min={0}
                                                          onBlur={(name, data) => {

                                                            if (values?.deliveries?.[index]?.uom_name && (values?.deliveries?.[index]?.uom_name.toUpperCase() == "CFT" || values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG")) {
                                                              let multiplyFactor = 0, actualValue = 0;
                                                              let tempVolume = 0;

                                                              let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;

                                                              for (
                                                                let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                              ) {
                                                                tempVolume = tempVolume +
                                                                  values?.deliveries?.[index]?.products[indx].quantity *
                                                                  values?.deliveries?.[index]?.products[indx]["length"] *
                                                                  values?.deliveries?.[index]?.products[indx].breadth *
                                                                  values?.deliveries?.[index]?.products[indx].height;
                                                              }

                                                              if (values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG" && values?.deliveries?.[index]?.cft_kg_factor && +values.deliveries[index].cft_kg_factor > 0) {
                                                                multiplyFactor = tempVolume * +values.deliveries[index].cft_kg_factor
                                                                setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                              } else {
                                                                multiplyFactor = tempVolume
                                                              }

                                                              actualValue = multiplyFactor * actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`, actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, values.deliveries[index].charges + +actualValue);
                                                            }
                                                          }}
                                                          onChange={(
                                                            value,
                                                            data
                                                          ) => {

                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].breadth`, data.value
                                                            );
                                                          }}
                                                        />{" "}
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].breadth`}
                                                            trans={
                                                              "product_form.breadth"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>

                                                      <Table.Cell>
                                                        <Fieldmik
                                                          component={MyNumInput}
                                                          label={
                                                            props.t(
                                                              "product_form.height"
                                                            ) || "Height"
                                                          }
                                                          placeholder={props.t(
                                                            "product_form.lbhPlaceholder"
                                                          )}
                                                          type="number"
                                                          name={`deliveries[${index}].products[${i}].height`}
                                                          // type="number"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].products[i].height
                                                          }
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            // width: "155px"
                                                          }}
                                                          min={0}
                                                          onBlur={(name, data) => {

                                                            if (values?.deliveries?.[index]?.uom_name && (values?.deliveries?.[index]?.uom_name.toUpperCase() == "CFT" || values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG")) {
                                                              let multiplyFactor = 0, actualValue = 0;
                                                              let tempVolume = 0;

                                                              let actualFreightValue = values?.deliveries?.[index]?.actual_freight_rate;

                                                              for (
                                                                let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                              ) {
                                                                tempVolume = tempVolume +
                                                                  values?.deliveries?.[index]?.products[indx].quantity *
                                                                  values?.deliveries?.[index]?.products[indx]["length"] *
                                                                  values?.deliveries?.[index]?.products[indx].breadth *
                                                                  values?.deliveries?.[index]?.products[indx].height;
                                                              }

                                                              if (values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG" && values?.deliveries?.[index]?.cft_kg_factor && +values.deliveries[index].cft_kg_factor > 0) {
                                                                multiplyFactor = tempVolume * +values.deliveries[index].cft_kg_factor
                                                                setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                              } else {
                                                                multiplyFactor = tempVolume
                                                              }

                                                              actualValue = multiplyFactor * actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`, actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, values.deliveries[index].charges + +actualValue);
                                                            }
                                                          }}
                                                          onChange={(
                                                            value,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].height`, data.value
                                                            );
                                                          }}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].height`}
                                                            trans={
                                                              "product_form.height"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Table.Row>
                                              </Table.Body>
                                            </Table>
                                          ))}
                                          <Button
                                            basic
                                            color="blue"
                                            className="m-2"
                                            type="button"
                                            onClick={() =>
                                              deliveryProducts.push({
                                                product_code: "",
                                                product_name: "",
                                                quantity: "",
                                              })
                                            }
                                            size="mini"
                                          >
                                            {" "}
                                            {props.t(
                                              "product_form.action_button.add_more_product"
                                            ) || "Add More Products"}{" "}
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    />
                                  </Table.Cell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          ))}
                          <Modal.Actions>
                            <center>
                              <Button
                                size="mini"
                                type="button"
                                onClick={() => addNewDelivery(arrayHelpers)}
                                basic
                                primary
                                icon
                              >
                                {" "}
                                <Icon name="plus" />{" "}
                                {props.t("action_button.new_delivery") ||
                                  "New Delivery"}{" "}
                              </Button>

                              <Button size="mini" primary type="submit" disabled={enableEwayDoc || enableInvoiceDoc || enableOtherDocs || enablePhysicalLR}>
                                {props.t("action_button.save") || "Save"}
                              </Button>

                              <Button
                                onClick={props.handleClose}
                                size="mini"
                                color="red"
                                type="button"
                              >
                                {" "}
                                {props.t("action_button.close") || "Close"}{" "}
                              </Button>
                            </center>
                          </Modal.Actions>
                          <Modal
                            onClose={() => setQuantityModal(false)}
                            onOpen={() => setQuantityModal(true)}
                            open={quantityModal}
                          >
                            <Modal.Content image>
                              Your Total Ordered Quantity and Product Quantity is Different
                              Can you Continue with that?
                            </Modal.Content>
                            <Modal.Actions>
                              <Button color='black' onClick={() => {
                                setQuantityModal(false)
                                setFieldValue(
                                  `deliveries[${quantityIndex}].total_quantity`, getCounts(values.deliveries[quantityIndex].products)
                                )
                                values.deliveries[quantityIndex].total_quantity = getCounts(values.deliveries[quantityIndex].products)
                              }}>
                                Nope
                              </Button>
                              <Button
                                content="Yes, Continue"
                                labelPosition='right'
                                icon='checkmark'
                                onClick={() => setQuantityModal(false)}
                                positive
                              />
                            </Modal.Actions>
                          </Modal>
                        </>
                      )}
                    />
                  </Formiker>
                </Modal.Description>
              </Modal.Content>
            );
          }}
        ></Formik>
      </Modal>
    </div>
  );
};

const mapStateToPrps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToPrps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher
})(translate("create_order")(ModalJobOrder));